// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-07T17:14:15.700Z
// Property: Baystone Apartments (ID: 6737460151192625)
// Collections: 39 amenities, 6 floorplans (live), 77 photos, 72 POIs, 4 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6737460151192625",
  "property_external_id": "4707259",
  "property_zillow_url": "https://www.zillow.com/homedetails/800-W-Nasa-Rd-1-APT-1-Webster-TX-77598/2130304877_zpid/",
  "property_apartments_url": "https://www.apartments.com/baystone-apartments-webster-tx/ggvsfwy",
  "property_google_business_url": "https://www.google.com/maps/place/Baystone+Apartments/data=!4m2!3m1!1s0x0:0x6cc75fcda77775c0?sa=X&ved=2ahUKEwi9kLDOxbySAxVz5skDHbpqG-QQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "17321291127",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "baystone-apartments",
  "property_name": "Baystone Apartments",
  "property_website_url": "https://www.baystoneapthome.com/",
  "property_domain": "https://www.baystoneapthome.com/",
  "property_address": "800 W Nasa Pkwy",
  "property_full_address": "800 W NASA Pkwy, Webster, TX 77598",
  "property_address_1": "800 W NASA Pkwy",
  "property_address_2": null,
  "property_address_city": "Webster",
  "property_address_state": "TX",
  "property_address_zip_full": "77598-4956",
  "property_address_zip": "77598",
  "property_address_country": "US",
  "property_address_county": "Harris County",
  "property_neighborhood_address": "Webster",
  "property_address_latitude": "29.533544",
  "property_address_longitude": "-95.12724589999999",
  "property_email": "baystone.mgr@rreafresidential.com",
  "property_phone": "(281) 332-2575",
  "property_call_tracking_phone": "281-377-4461",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Baystone Apartments in Webster, TX! Choose from our spacious one, two, and three-bedroom floor plans, perfect for any lifestyle. Enjoy exceptional amenities like on-site management, package receiving, and short-term leases. Find your new home today—browse our availability or schedule a tour of our vibrant community!",
  "property_long_description": "Welcome to Baystone Apartments, your ideal residence in the heart of Webster, TX. Offering an array of thoughtfully designed floor plans, including spacious one, two, and three-bedroom apartments, we provide the perfect backdrop for your lifestyle. Settle into your new home with ease and comfort, surrounded by a community that prioritizes your needs.\n\nAt Baystone Apartments, we understand that convenience is key. Our on-site management team is dedicated to providing top-notch service, ensuring that your living experience is seamless. Enjoy hassle-free package receiving and on-site maintenance that makes your day-to-day life more enjoyable. Plus, with short-term lease options available, you have the flexibility to stay as long as you need, making us the perfect choice whether you’re looking for a temporary space or a long-term home.\n\nAs a Price Leader in the market, Baystone Apartments not only offers competitive pricing but also a commitment to quality living. Take advantage of our fantastic amenities and discover a welcoming environment designed for comfort and convenience. \n\nDon’t miss out on the opportunity to make Baystone Apartments your new home. Explore our availability today or schedule a tour to experience our community firsthand. Your perfect apartment awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60db-2759-72c9-9db1-a44e34599635.webp",
  "property_featured_image_media": {
    "alt_text": "Courtyard with a decorative water feature and bridge, surrounded by apartment buildings.",
    "public_id": "019e60db-2759-72c9-9db1-a44e34599635",
    "storage_key": "property/6737460151192625/019e60db-2759-72c9-9db1-a44e34599635.webp",
    "width": 3072,
    "height": 2048
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "290",
  "property_year_built": "1968",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.82758620689656",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "75",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Cats and dogs are welcome with breed restrictions. Maximum of 2 pets per apartment.",
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://baystoneapartments.loftliving.com/login",
  "property_apply_now_url": "https://8444221.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-a51e-727e-b22d-ba846b30af0c.webp",
  "property_primary_logo_media": {
    "alt_text": "Baystone Apartments logo with an anchor.",
    "public_id": "019e1dfa-a51e-727e-b22d-ba846b30af0c",
    "storage_key": "property/6737460151192625/019e1dfa-a51e-727e-b22d-ba846b30af0c.webp",
    "width": 574,
    "height": 194
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-961a-70dc-a0ec-57ec1c475a38.webp",
  "property_secondary_logo_media": {
    "alt_text": "Baystone Apartments logo with an anchor.",
    "public_id": "019e1dfa-961a-70dc-a0ec-57ec1c475a38",
    "storage_key": "property/6737460151192625/019e1dfa-961a-70dc-a0ec-57ec1c475a38.webp",
    "width": 1100,
    "height": 366
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e8e87-4a31-736b-83c1-17de6998e154.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019e8e87-4a31-736b-83c1-17de6998e154",
    "storage_key": "property/6737460151192625/019e8e87-4a31-736b-83c1-17de6998e154.webp",
    "width": 574,
    "height": 194
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e8e87-3c12-77bc-81cf-9b1ee221650e.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019e8e87-3c12-77bc-81cf-9b1ee221650e",
    "storage_key": "property/6737460151192625/019e8e87-3c12-77bc-81cf-9b1ee221650e.webp",
    "width": 574,
    "height": 194
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#174978",
  "property_secondary_color": "#36a4ba",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2 - 3",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "665 - 1340",
  "property_sqft_min": "665",
  "property_sqft_max": "1340",
  "property_price_range": "899 - 1699",
  "property_price_min": "899",
  "property_price_max": "1699",
  "property_available_units": 15,
  "property_facebook_url": "https://www.facebook.com/people/Baystone-Apartments/61555199851489/#",
  "property_instagram_url": "https://www.instagram.com/baystone_rrliving/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ6UXiXZScQIYRwHV3p81fx2w",
  "property_youtube_url": "https://www.youtube.com/watch?t=276&v=9vYnh6rC_lc",
  "property_yelp_url": "https://www.yelp.com/biz/baystone-apartments-webster",
  "property_tiktok_url": "https://www.tiktok.com/@baystone.apts",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Baystone Apartments",
  "property_home_romance_title": "Embrace the Joy of Living in Our Charming Community",
  "property_home_amenities_blurb": "<p>Baystone Apartments offer affordability with a selection of one, two, or three bedroom <a href=\"/floor-plans/\">apartments</a> for rent and seven floor plan options to fit your needs. Our apartment homes feature faux wood flooring, vertical blinds, and oversized closets. Enjoy chef-inspired meals in your fully-equipped gourmet kitchen with a pantry, dishwasher, and frost-free refrigerator. Relish the extras, like a mirrored dining area, two-tone paint, double stainless steel sinks, and a linen closet.</p>\n<p>Come and indulge in life's simple pleasures at the affordable Baystone Apartments in Webster, Texas!</p>",
  "property_home_floorplans_blurb": "<p>Live where you work and play by residing at Baystone <a href=\"/floor-plans/\">Apartments</a> in the heart of Webster, TX. Located close to Interstate 45, you will find various shopping opportunities and outdoor adventures like Kemah Boardwalk and Galveston Island Waterpark. There's always something to do, including a visit to the NASA Johnson Space Center. The essentials or a good time are always only minutes away!</p>",
  "property_home_gallery_blurb": "At Baystone Apartments in Webster, TX, vibrant living meets modern comfort. Choose from stylish one, two, or three-bedroom layouts, complete with thoughtful amenities like a refreshing pool, fitness center, and picnic area. Enjoy 24-hour access and planned social activities, all in a welcoming, gated community. Picture yourself living here!",
  "property_home_neighborhood_blurb": "Discover the vibrant neighborhood surrounding Baystone Apartments in Webster, TX. With comfortable one, two, and three-bedroom floor plans, our community is perfect for everyone. Explore local favorites and nearby points of interest to enhance your living experience. See what's around and find your next adventure today!",
  "property_home_reviews_blurb": "At Baystone Apartments in Webster, TX, residents rave about the seamless blend of comfort and convenience. With a rating of 4.5, one resident shares, “...it’s boosted my morale,” highlighting easy access to amenities. Experience affordable living with attentive service—your perfect home awaits! ",
  "property_neighborhood_blurb": "<p>Live where you work and play by residing at Baystone <a href=\"/floor-plans/\">Apartments</a> in the heart of Webster, TX. Located close to Interstate 45, you will find various shopping opportunities and outdoor adventures like Kemah Boardwalk and Galveston Island Waterpark. There's always something to do, including a visit to the NASA Johnson Space Center. The essentials or a good time are always only minutes away!</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Quality standard amenities and many extra enhancements are what you will discover at Baystone <a href=\"/floor-plans/\">Apartments in Webster</a>, TX. We provide fully-equipped kitchens, central air and heating, a mirrored dining area, and two-tone paint, just to name a few!</p>",
  "property_applynow_blurb": "Discover your perfect living space at Baystone Apartments in Webster, TX! Choose from our stylish one, two, and three-bedroom floor plans, complemented by top-notch amenities like on-site management and maintenance. Enjoy short-term lease options and hassle-free package receiving. Find your new home and lease online today!",
  "property_contactus_blurb": "Explore Baystone Apartments in Webster, TX, offering spacious one, two, and three-bedroom floor plans to suit your lifestyle. Ready to find your perfect home? View all options and discover your ideal living space today. Have questions? Contact our leasing team for personalized assistance!",
  "property_faqs_blurb": "Discover your ideal living space at Baystone Apartments in Webster, TX! Choose from our stylish one, two, or three-bedroom floor plans, designed to suit your lifestyle. Have questions? Browse our FAQs page for answers about our community and amenities. We're here to help you find your perfect home!",
  "property_floorplans_blurb": "<p>Choose your favorite floor plans and then compare size, pricing, and <a href=\"/amenities/\">amenities</a> available in our one, two, or three bedroom apartments for rent in Webster, TX. Make Baystone Apartments your new home today!</p>",
  "property_gallery_blurb": "<p>Nothing helps you to imagine the possibilities for a new apartment home quite like photography. Take a look at photo collections that capture the unique and beautiful spaces in our community and <a href=\"/floor-plans/\">apartments</a>.</p>",
  "property_interactivemap_blurb": "Discover Baystone Apartments in Webster, TX, featuring spacious one, two, and three-bedroom floor plans to suit your lifestyle. Enjoy top-notch amenities like on-site management, package receiving, and short-term leases. Use our interactive community map to explore available apartments and pricing—your new home awaits!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "Discover the perfect home at Baystone Apartments in Webster, TX! Choose from spacious one, two, and three-bedroom floor plans designed for comfort and style. Great friends make great neighbors—refer a friend to our community today and enjoy the benefits of living side by side! View all options now!",
  "property_residentaccess_blurb": "Welcome to Baystone Apartments in Webster, TX! Explore our diverse property floor plans, offering one, two, and three-bedroom layouts. Enhance your living experience by accessing our resident portal today to conveniently pay rent, schedule maintenance, and enjoy a seamless community lifestyle. Your comfort is just a click away!",
  "property_reviews_blurb": "At Baystone Apartments in Webster, TX, residents rave about the \"wonderful service\" and professional staff who are always ready to assist. With affordable living and modern renovations, it's no wonder our community fosters a vibrant atmosphere perfect for singles and families alike. See what our residents have to say about living here!",
  "property_created_at": "1752257252729",
  "property_scheduletour_blurb": "Discover your perfect home at Baystone Apartments in Webster, TX! Choose from stylish one, two, and three-bedroom floor plans tailored for your lifestyle. Schedule a tour today and see what our residents have to say about living in our welcoming community. Your ideal apartment awaits!",
  "property_thankyou_blurb": "Thank you for your interest in Baystone Apartments in Webster, TX! Explore our inviting floor plans, featuring one, two, and three-bedroom options designed for your comfort and lifestyle. Our team will reach out shortly to assist you in finding your perfect home. We look forward to welcoming you!",
  "property_virtualtours_blurb": "<p>At Baystone, we make finding your new home quick & easy with our beautiful virtual tours. Explore 360-degree views of your new apartment home & the exceptional amenities that accompany it.</p>",
  "property_copyright": "2025 All Rights Reserved. Baystone Apartments",
  "property_seo_title_home": "Baystone Apartments | Apartments in Webster, TX",
  "property_seo_description_home": "Discover your perfect space at Baystone Apartments in Webster, TX! Choose from a variety of one, two, and three-bedroom floor plans designed for comfort and style. Enjoy top-notch amenities including on-site management, package receiving, and convenient short-term leases. With dedicated on-site maintenance and competitive pricing, Baystone is the price leader in the area. Find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Webster, TX",
  "property_seo_description_floorplans": "Discover your ideal living space at Baystone Apartments in Webster, TX! Explore our diverse range of floor plans, including cozy one-bedroom layouts, spacious two-bedroom options, and luxurious three-bedroom designs. Whether you're seeking comfort or room to grow, we have the perfect apartment for you. Browse our available apartment homes today and find your perfect floor plan at Baystone Apartments!",
  "property_seo_title_amenities": "Amenities | Webster, TX Apartments for Rent",
  "property_seo_description_amenities": "Discover the exceptional amenities at Baystone Apartments in Webster, TX! Explore our diverse floor plans—one, two, and three bedrooms—designed for your lifestyle. Enjoy on-site management, convenient package receiving, and flexible short-term leases. With a strong focus on resident satisfaction, we’re proud to be the price leader in the area! Visit our Amenities page and experience community living at its best. Explore now!",
  "property_seo_title_gallery": "Gallery | Apartments in Webster, TX",
  "property_seo_description_gallery": "\"Explore the stunning Photo Gallery of Baystone Apartments in Webster, TX, featuring spacious one, two, and three-bedroom floor plans. Enjoy top-notch amenities like on-site management, package receiving, and maintenance, plus flexible short-term leases. Picture yourself living here – your dream home awaits!\"",
  "property_seo_title_virtualtours": "Virtual Tours | Baystone Apartments Apartments",
  "property_seo_description_virtualtours": "Discover your perfect home at Baystone Apartments in Webster, TX! Explore our diverse floor plans, including one, two, and three-bedroom options, designed for comfort and style. Take a virtual tour today to experience our vibrant community and find your ideal apartment for rent. Don’t miss out—book your tour now!",
  "property_seo_title_interactivemap": "Interactive Map | Baystone Apartments Apartments",
  "property_seo_description_interactivemap": "Discover your new home at Baystone Apartments in Webster, TX! Choose from our spacious one, two, and three-bedroom floor plans, all designed for comfort. Enjoy top-notch amenities including on-site management, package receiving, and convenient short-term leases. Explore our interactive community map to view available apartments, compare pricing, and find the perfect fit for your lifestyle. Your dream apartment awaits—start your search today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Webster, TX",
  "property_seo_description_neighborhood": "Discover the vibrant lifestyle waiting for you at Baystone Apartments in Webster, TX! Explore our diverse floor plans, including one, two, and three-bedroom options, and see what's around our community. From local favorites to must-visit points of interest, there’s something for everyone. Join us and experience the best of neighborhood living!",
  "property_seo_title_contact": "Contact Us | Baystone Apartments",
  "property_seo_description_contact": "Discover your perfect home at Baystone Apartments in Webster, TX! Explore our diverse floor plans, including spacious one, two, and three-bedroom options tailored to your lifestyle. Have questions? Contact our leasing team today for more information and start your journey to comfortable living!",
  "property_seo_title_faqs": "FAQs | Apartments in Webster, TX",
  "property_seo_description_faqs": "Discover Baystone Apartments in Webster, TX! Explore our diverse floor plans, including one, two, and three-bedroom options, and learn about our exceptional amenities like on-site management, package receiving, and flexible short-term leases. Have questions? Browse our FAQs page to find answers to all your inquiries about our vibrant community and discover why we’re the price leader in the area!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Webster, TX",
  "property_seo_description_reviews": "Discover why residents love calling Baystone Apartments in Webster, TX home! Explore our diverse floor plans, including one, two, and three-bedroom options, and enjoy top-notch amenities like on-site management, package receiving, and flexible short-term leases. Don’t just take our word for it—see what our residents have to say about their experience in our vibrant community. Join us today and find out why we’re the price leader in the area!",
  "property_seo_title_applynow": "Apply Now | Apartments in Webster, TX",
  "property_seo_description_applynow": "Discover your perfect home at Baystone Apartments in Webster, TX! Choose from our thoughtfully designed one, two, and three-bedroom floor plans. Enjoy convenient amenities like on-site management, package receiving, and hassle-free maintenance. With flexible short-term lease options and unbeatable pricing, you're just a click away from leasing your new apartment. Apply now and find your dream home today!",
  "property_seo_title_residentaccess": "Resident Access | Baystone Apartments",
  "property_seo_description_residentaccess": "\"Welcome to the Baystone Apartments Resident Access Login page! Conveniently manage your living experience in Webster, TX by accessing your resident portal. Pay rent, schedule maintenance, and enjoy exclusive resident benefits. Log in now for hassle-free living!\"",
  "property_seo_title_referafriend": "Refer A Friend | Baystone Apartments",
  "property_seo_description_referafriend": "\"Love living at Baystone Apartments in Webster, TX? Share the joy! Refer a friend today and enjoy the perks of great neighbors in our vibrant community. Join us in creating a welcoming home for you and your friends!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Baystone Apartments",
  "property_seo_description_scheduletour": "\"Explore your new home at Baystone Apartments in Webster, TX! Schedule a tour today to experience our vibrant community, modern amenities, and spacious floor plans. Discover why Baystone is the perfect place for you!\"",
  "property_seo_title_privacy": "Privacy Policy | Baystone Apartments",
  "property_seo_description_privacy": "\"Discover the commitment to your privacy at Baystone Apartments in Webster, TX. Our privacy policy outlines how we protect your information and ensure a secure living experience. Transparent and trustworthy, we prioritize your peace of mind. View our privacy policy today!\"",
  "property_seo_title_accessibility": "Website Accessibility | Baystone Apartments",
  "property_seo_description_accessibility": "Discover Baystone Apartments in Webster, TX, where accessibility meets comfort. Our commitment to digital inclusion ensures that everyone can enjoy our community. Explore our Accessibility Statement to see how we foster an inclusive environment for all residents and visitors. Join us today!",
  "property_seo_title_sitemap": "Sitemap | Baystone Apartments",
  "property_seo_description_sitemap": "Discover the seamless living experience at Baystone Apartments in Webster, TX! Explore our sitemap to easily navigate through our community features, amenities, and available apartments. Visit now to find your perfect home!",
  "property_seo_title_thankyou": "Thank You | Baystone Apartments",
  "property_seo_description_thankyou": "Thank you for your interest in Baystone Apartments in Webster, TX! Your submission has been received, and a member of our team will reach out soon to assist you. Explore our vibrant community and discover the perfect place to call home!",
  "property_seo_title_pets": "Pet Policy | Apartments in Webster, TX",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293558189",
  "amenities": [
    {
      "id": "custom_a517dd7a-77d3-4363-b848-73ba74137e67",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "external_id": "false",
      "title": "Two Shimmering Swimming Pools with Outdoor Lounge and Spa",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2cbc459f-e30c-43fa-9bde-cb7f2d93a434",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "external_id": "false",
      "title": "Social Terrace with Barbecue",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_74fbfb85-3c89-4d46-be5c-6f01dd6b36fc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "external_id": "false",
      "title": "24‑Hour State‑of‑the‑art Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_54afae27-0c7d-4e69-821a-9e222c942215",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8f33a530-be76-43d3-bef1-1badc65ba8d2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "external_id": "false",
      "title": "Pet‑Friendly Walking Paths",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_502d70f0-659c-4a40-a23b-cf42edde655a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "external_id": "false",
      "title": "Lagoon and Courtyards with Outdoor Seating and Walking Paths",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0dfea8e0-dae9-4bd1-9d3a-2c58e36600ea",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "external_id": "false",
      "title": "Coffee and Tea Bar",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8d33577d-9882-4fd8-9934-88e2352e402b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "external_id": "false",
      "title": "Resident Exclusive Clubhouse with Free WIFI",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_95f7c074-3c01-4593-be35-4aea7c9f0485",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "external_id": "false",
      "title": "Common Area Laundry Facility",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_600cd2c4-d0ca-4cd8-accc-b5cd77892b2c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "external_id": "false",
      "title": "Reserved Covered Parking Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cb858db9-bdf2-4b9f-b4a5-4f0fa7aaf33a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "external_id": "false",
      "title": "Guest Parking Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0ebfe65d-9df0-4dbb-862b-aad25e77e16d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "external_id": "false",
      "title": "Controlled Access Community",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6a77f83e-bf1c-446d-a1c4-a83d89573ab2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "external_id": "false",
      "title": "Lush Greenery and Beautiful Landscaping",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fd76c59b-eb16-4513-8bfc-6b1ffd84007b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "external_id": "false",
      "title": "24‑Hour Resident Portal",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_863497a9-3324-457a-a959-61bc12adcd3b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "external_id": "false",
      "title": "Online Rent Payments",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_afaf97b5-dfbc-4a46-aa84-e65477d39109",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "external_id": "false",
      "title": "Flexible Rent Payment Program",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_95eb3229-dba6-49d0-9537-c4b33d82dde0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "external_id": "false",
      "title": "Professional On‑site Management",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_db4341cc-23dc-46fe-94b7-d91a82eecd24",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "external_id": "false",
      "title": "Professional On‑site Maintenance with 24‑Hour Emergency Service",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cd83ed58-c22d-452a-972a-74f77c08dd6c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "external_id": "false",
      "title": "Active Community Events",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b1d7d26f-c6a6-4eb9-89d3-4fa3529918a5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "external_id": "false",
      "title": "Flexible Leasing Terms",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_079251ef-5cce-4b3b-932e-801640f7a78f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "external_id": "false",
      "title": "Conveniently Located Near Public Transportation, Freeways, Shopping, and Restaurants",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_83d3c074-16f6-4937-8b40-2212dd716a3a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious Floorplans with Extra‑Large Square Footage",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9d2c243d-cbcc-49a2-8474-c82ded0ba4b9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "external_id": "false",
      "title": "Luxury Wood‑Designed and Carpeted Flooring",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2d8ad6f8-cdab-47d8-b912-9613ae6194b8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "external_id": "false",
      "title": "Energy‑Efficient, Modern Black Appliances",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d74bcd5d-4849-421c-85d4-7163b681f407",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "external_id": "false",
      "title": "Chef‑Ready Kitchen with Built‑In Microwave*",
      "amount": "false",
      "description": "In select apartment homes.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ec6d3edc-df21-4c68-bbda-af447bee4c86",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "external_id": "false",
      "title": "Custom‑Feel Cabinetry with Select Upgrades*",
      "amount": "false",
      "description": "In select apartment homes.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_52d15b84-af2c-44c7-9c30-b64d6c937fe2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "external_id": "false",
      "title": "Breakfast and Wet Bar*",
      "amount": "false",
      "description": "In select apartment homes.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_13ae3564-7881-4ba2-b225-a3e83627bf10",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "external_id": "false",
      "title": "Gooseneck Faucet*",
      "amount": "false",
      "description": "In select apartment homes.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1f54f9e4-ed39-488c-8315-66fc73133fef",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "external_id": "false",
      "title": "Expansive Walk‑In Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_38846f6e-c8ce-40f1-8109-7f937e93bea5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans with Decorative Light Kits in Living Areas and Bedrooms",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e7125022-a569-4897-9a63-5de451abb821",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "external_id": "false",
      "title": "Renovated Homes with Modern LED Lighting*",
      "amount": "false",
      "description": "In select apartment homes.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3df34b99-0465-435b-bf90-440d42e7bd94",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "external_id": "false",
      "title": "Coat Closet for Additional Storage",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ca431f0e-3948-44cc-8101-334893dffacd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "external_id": "false",
      "title": "Washer and Dryer Connections*",
      "amount": "false",
      "description": "In select apartment homes.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7d1734be-de05-4477-bd35-3c3859b30d87",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "external_id": "false",
      "title": "Renovated Homes*",
      "amount": "false",
      "description": "In select apartment homes.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fdf6582c-8e7a-46df-9717-77f34297524c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "external_id": "false",
      "title": "2\" Faux Wood Blinds*",
      "amount": "false",
      "description": "In select apartment homes.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_502443e3-b63b-4d6e-930d-2cd2adacc13c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "external_id": "false",
      "title": "Central Air and Heating",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fcedc42f-e6a4-4c42-8f45-32e4cfa8841c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "external_id": "false",
      "title": "High‑speed Internet Access and Cable Available",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5f5a49b2-150c-4ec7-a1e2-9cb26b3261fe",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "external_id": "false",
      "title": "Desirable Views Available*",
      "amount": "false",
      "description": "In select apartment homes.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6e006697-0681-4182-ae66-4ac3951177ba",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "external_id": "false",
      "title": "Disability Access",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_b44db127-fcb0-40fe-93ab-73b40eb467c7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60da-a531-74be-b0fe-cb0f234c4e61.webp",
      "image_media": {
        "alt_text": "Aerial view of a courtyard with a waterfall, pool, and lush landscaping.",
        "public_id": "019e60da-a531-74be-b0fe-cb0f234c4e61",
        "storage_key": "property/6737460151192625/019e60da-a531-74be-b0fe-cb0f234c4e61.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Community",
      "description": "Discover our beautiful courtyard featuring a cascading waterfall, serene pool, and vibrant greenery, creating a tranquil oasis for residents.",
      "link": "",
      "alt_text": "Aerial view of a courtyard with a waterfall, pool, and lush landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_97bd32ea-0024-43d9-8f80-4404b7a051ea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019fb353-b6dd-7679-b464-555a33acbf58.webp",
      "image_media": {
        "alt_text": "Modern kitchen with black appliances, grey cabinets, and stainless steel sink.",
        "public_id": "019fb353-b6dd-7679-b464-555a33acbf58",
        "storage_key": "property/6737460151192625/019fb353-b6dd-7679-b464-555a33acbf58.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Discover a sleek and functional kitchen featuring modern black appliances, ample grey cabinetry, and a deep stainless steel sink. Perfect for everyday cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with black appliances, grey cabinets, and stainless steel sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b7b08cbc-08fe-491a-a79b-11e4012af60e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60db-6219-7607-9f42-81db496b3706.webp",
      "image_media": {
        "alt_text": "Living room and dining area with modern furniture, including a sofa, armchair, and dining table.",
        "public_id": "019e60db-6219-7607-9f42-81db496b3706",
        "storage_key": "property/6737460151192625/019e60db-6219-7607-9f42-81db496b3706.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring contemporary furnishings, a stylish sofa, and a comfortable armchair, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room and dining area with modern furniture, including a sofa, armchair, and dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ea0e5ec4-43ff-46fc-ba7a-6734ea25b80d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019fb353-bb95-76af-a41f-c069c585d4fd.webp",
      "image_media": {
        "alt_text": "Bedroom with a dresser, mirror, and bed.",
        "public_id": "019fb353-bb95-76af-a41f-c069c585d4fd",
        "storage_key": "property/6737460151192625/019fb353-bb95-76af-a41f-c069c585d4fd.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a dresser, a round mirror, and a comfortable bed with decorative pillows and a throw blanket.",
      "link": "",
      "alt_text": "Bedroom with a dresser, mirror, and bed.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_15edaaee-e700-4304-a3a9-40f4eb34a806",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019fb353-b632-7751-b321-ebc3f1cd5000.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio machines, weight machines, and mirrors.",
        "public_id": "019fb353-b632-7751-b321-ebc3f1cd5000",
        "storage_key": "property/6737460151192625/019fb353-b632-7751-b321-ebc3f1cd5000.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a variety of cardio and weight training equipment.",
      "link": "",
      "alt_text": "Fitness center with cardio machines, weight machines, and mirrors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8486698e-9e41-4409-96f5-af6f52047d96",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60da-da69-77ce-95fc-98af45220a75.webp",
      "image_media": {
        "alt_text": "Modern kitchen and living room with dining area in an apartment.",
        "public_id": "019e60da-da69-77ce-95fc-98af45220a75",
        "storage_key": "property/6737460151192625/019e60da-da69-77ce-95fc-98af45220a75.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Step into a bright and airy living space, featuring a modern kitchen with ample cabinet space, a comfortable living room, and a dedicated dining area, perfect for entertaining.",
      "link": "",
      "alt_text": "Modern kitchen and living room with dining area in an apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_94025995-9ed6-498e-9018-fed91511dbb4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019fb353-bbde-71f9-9eaf-89e2cd1e8f52.webp",
      "image_media": {
        "alt_text": "A cozy bedroom with a queen-size bed, modern art, and a closet.",
        "public_id": "019fb353-bbde-71f9-9eaf-89e2cd1e8f52",
        "storage_key": "property/6737460151192625/019fb353-bbde-71f9-9eaf-89e2cd1e8f52.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush queen-size bed, striking modern art, and ample closet space for all your belongings.",
      "link": "",
      "alt_text": "A cozy bedroom with a queen-size bed, modern art, and a closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8918bb30-20f3-4a14-b673-8ac9204b0e98",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60db-9349-7218-a640-b6b7fe8151fa.webp",
      "image_media": {
        "alt_text": "Resort-style outdoor swimming pool with lounge chairs and umbrellas outside apartment buildings.",
        "public_id": "019e60db-9349-7218-a640-b6b7fe8151fa",
        "storage_key": "property/6737460151192625/019e60db-9349-7218-a640-b6b7fe8151fa.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded seating areas. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Resort-style outdoor swimming pool with lounge chairs and umbrellas outside apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_87f01215-af33-4c25-a064-342ee6e2c3ba",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60db-87bb-7619-b832-344f3fe2055a.webp",
      "image_media": {
        "alt_text": "Stylish modern lounge area with a striking blue fireplace, plush green sofa, and comfortable seating.",
        "public_id": "019e60db-87bb-7619-b832-344f3fe2055a",
        "storage_key": "property/6737460151192625/019e60db-87bb-7619-b832-344f3fe2055a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully designed lounge. Featuring a modern fireplace, ample seating, and a communal table, it's the perfect space to socialize or work.",
      "link": "",
      "alt_text": "Stylish modern lounge area with a striking blue fireplace, plush green sofa, and comfortable seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1dd383cd-e581-4d12-a0c2-155e43929cb0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/01a0fdee-a70c-765b-8b45-b66cd2fc8b2e.webp",
      "image_media": {
        "alt_text": "Laundry room with rows of washers and dryers, ceiling fans, and a table.",
        "public_id": "01a0fdee-a70c-765b-8b45-b66cd2fc8b2e",
        "storage_key": "property/6737460151192625/01a0fdee-a70c-765b-8b45-b66cd2fc8b2e.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities equipped with multiple washers and dryers, ensuring easy access for residents. Ceiling fans provide comfort.",
      "link": "",
      "alt_text": "Laundry room with rows of washers and dryers, ceiling fans, and a table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d3b287dc-824a-4939-97c2-40ca6e87ede8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019fb353-b644-74e6-a908-315f5c14478e.webp",
      "image_media": {
        "alt_text": "Community lounge with foosball table, orange sectional sofa, and seating areas.",
        "public_id": "019fb353-b644-74e6-a908-315f5c14478e",
        "storage_key": "property/6737460151192625/019fb353-b644-74e6-a908-315f5c14478e.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy leisure time in our vibrant community lounge, featuring a foosball table, comfortable seating, and gathering spaces.",
      "link": "",
      "alt_text": "Community lounge with foosball table, orange sectional sofa, and seating areas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_df6472c8-748d-46b7-8afb-43606c2d6627",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60db-2394-706e-86f7-437a4262e7b8.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-sized bed, a closet, and a decorative wall piece.",
        "public_id": "019e60db-2394-706e-86f7-437a4262e7b8",
        "storage_key": "property/6737460151192625/019e60db-2394-706e-86f7-437a4262e7b8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-sized bed, ample closet space, and elegant decor, creating a serene retreat.",
      "link": "",
      "alt_text": "Bedroom with a king-sized bed, a closet, and a decorative wall piece.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_956e5d4b-8bd0-457e-8eb2-faa48d6679a1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60db-79fc-77df-8179-50177ebb209f.webp",
      "image_media": {
        "alt_text": "Fitness center with weight machines, treadmills, and elliptical trainers.",
        "public_id": "019e60db-79fc-77df-8179-50177ebb209f",
        "storage_key": "property/6737460151192625/019e60db-79fc-77df-8179-50177ebb209f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Our well-equipped fitness center offers a variety of machines for a complete workout, including weight machines, treadmills, and ellipticals.",
      "link": "",
      "alt_text": "Fitness center with weight machines, treadmills, and elliptical trainers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8a84e609-64b3-4794-88f1-40b8d0965f74",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60db-9106-7702-b0a6-1c230a08aaa8.webp",
      "image_media": {
        "alt_text": "Lobby with blue velvet chairs around a geometric coffee table and a modern fireplace.",
        "public_id": "019e60db-9106-7702-b0a6-1c230a08aaa8",
        "storage_key": "property/6737460151192625/019e60db-9106-7702-b0a6-1c230a08aaa8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in the stylish lobby, featuring comfortable seating and a striking modern fireplace.",
      "link": "",
      "alt_text": "Lobby with blue velvet chairs around a geometric coffee table and a modern fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e5035499-f11b-4fb0-af42-6d4c90b01b3d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60db-ae95-70a9-96eb-b38634e77add.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with grills and picnic tables under a pergola.",
        "public_id": "019e60db-ae95-70a9-96eb-b38634e77add",
        "storage_key": "property/6737460151192625/019e60db-ae95-70a9-96eb-b38634e77add.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings with friends and family in our community's barbecue and dining area, complete with grills and shaded seating.",
      "link": "",
      "alt_text": "Outdoor seating area with grills and picnic tables under a pergola.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9d36382d-c902-4de8-8331-1e4d0912f399",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60db-4156-778c-a71a-7f0d06aeef0f.webp",
      "image_media": {
        "alt_text": "Black refrigerator, microwave, and stove in a kitchen with gray cabinets.",
        "public_id": "019e60db-4156-778c-a71a-7f0d06aeef0f",
        "storage_key": "property/6737460151192625/019e60db-4156-778c-a71a-7f0d06aeef0f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring a black refrigerator, microwave, and stove. Ample cabinet space and a clean countertop make this a functional and stylish space.",
      "link": "",
      "alt_text": "Black refrigerator, microwave, and stove in a kitchen with gray cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_57c4dcec-4a83-4590-be05-4cba982ea421",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60da-a2f0-7546-857f-093822ce1630.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings surrounding a lush courtyard with pathways and a decorative water feature.",
        "public_id": "019e60da-a2f0-7546-857f-093822ce1630",
        "storage_key": "property/6737460151192625/019e60da-a2f0-7546-857f-093822ce1630.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Community",
      "description": "Discover the beautifully landscaped courtyards and inviting exteriors of our apartment community, designed for comfortable living.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings surrounding a lush courtyard with pathways and a decorative water feature.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_79136bb9-d36e-4e99-bdcf-63bc58de3048",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60db-8e71-7658-a69d-703e3f4e6c08.webp",
      "image_media": {
        "alt_text": "Community lounge area with a full-service bar, seating, and large windows.",
        "public_id": "019e60db-8e71-7658-a69d-703e3f4e6c08",
        "storage_key": "property/6737460151192625/019e60db-8e71-7658-a69d-703e3f4e6c08.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and socialize in our vibrant community lounge, featuring a full-service bar and comfortable seating areas perfect for gathering.",
      "link": "",
      "alt_text": "Community lounge area with a full-service bar, seating, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_90c6aeee-625f-470a-aa52-f8119f98d26c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60db-83d7-76e8-9f52-d02817a43ff6.webp",
      "image_media": {
        "alt_text": "Modern lounge area with blue velvet chairs and a fireplace.",
        "public_id": "019e60db-83d7-76e8-9f52-d02817a43ff6",
        "storage_key": "property/6737460151192625/019e60db-83d7-76e8-9f52-d02817a43ff6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax in our stylish lounge, featuring comfortable seating and a contemporary fireplace. The perfect space to unwind or socialize.",
      "link": "",
      "alt_text": "Modern lounge area with blue velvet chairs and a fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_105dbd19-5f88-49e4-872c-8462c9faad79",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60db-8999-73a3-9942-8088214663db.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a covered patio area.",
        "public_id": "019e60db-8999-73a3-9942-8088214663db",
        "storage_key": "property/6737460151192625/019e60db-8999-73a3-9942-8088214663db.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, perfect for relaxing and unwinding. Lounge chairs and a covered patio area provide ample space for sunbathing and shade.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and a covered patio area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_78fe4e2f-2c1f-4486-afe9-be24cc665347",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019fb353-b636-76aa-bfee-5f2fb51598ac.webp",
      "image_media": {
        "alt_text": "Modern kitchen and living area with bar seating and lounge chairs.",
        "public_id": "019fb353-b636-76aa-bfee-5f2fb51598ac",
        "storage_key": "property/6737460151192625/019fb353-b636-76aa-bfee-5f2fb51598ac.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area featuring a sleek kitchen island with bar stools and comfortable seating, perfect for entertaining.",
      "link": "",
      "alt_text": "Modern kitchen and living area with bar seating and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9d3e64c7-c7cb-44f7-a597-2049e169e91a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60db-8165-755b-b05c-8622f378451b.webp",
      "image_media": {
        "alt_text": "Fitness center gym with weights, exercise mats, and weight machines.",
        "public_id": "019e60db-8165-755b-b05c-8622f378451b",
        "storage_key": "property/6737460151192625/019e60db-8165-755b-b05c-8622f378451b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center is equipped with everything you need for a great workout, including free weights, cardio machines, and yoga mats.",
      "link": "",
      "alt_text": "Fitness center gym with weights, exercise mats, and weight machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4ee865ab-5518-4b9b-8273-c51334be8647",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60db-6c43-777b-acdd-812e5af87c3b.webp",
      "image_media": {
        "alt_text": "A communal lounge area with an orange sectional sofa, blue chairs, and tables by large windows.",
        "public_id": "019e60db-6c43-777b-acdd-812e5af87c3b",
        "storage_key": "property/6737460151192625/019e60db-6c43-777b-acdd-812e5af87c3b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax in our stylish communal lounge, featuring comfortable seating and a modern design, perfect for socializing or unwinding.",
      "link": "",
      "alt_text": "A communal lounge area with an orange sectional sofa, blue chairs, and tables by large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_833b883e-57f5-4c86-96f2-0fb7025a516c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60db-a22c-760d-b3b9-db7005cf83e4.webp",
      "image_media": {
        "alt_text": "Playground area with slides and climbing structures.",
        "public_id": "019e60db-a22c-760d-b3b9-db7005cf83e4",
        "storage_key": "property/6737460151192625/019e60db-a22c-760d-b3b9-db7005cf83e4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at the children's playground, complete with slides and climbing structures for endless entertainment.",
      "link": "",
      "alt_text": "Playground area with slides and climbing structures.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c0db279d-6d70-48e7-825e-013b2bdd0243",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60db-6474-72cf-a699-ed09812cc2f0.webp",
      "image_media": {
        "alt_text": "Sitting area with tables and chairs overlooking the courtyard.",
        "public_id": "019e60db-6474-72cf-a699-ed09812cc2f0",
        "storage_key": "property/6737460151192625/019e60db-6474-72cf-a699-ed09812cc2f0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our comfortable resident lounge, perfect for casual meetings or enjoying a quiet moment.",
      "link": "",
      "alt_text": "Sitting area with tables and chairs overlooking the courtyard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4e0b81a0-e679-467d-8a09-5f8bf941a0b1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60db-59a8-71dd-a84a-a53d9607d535.webp",
      "image_media": {
        "alt_text": "Modern living room and kitchen area with dining table",
        "public_id": "019e60db-59a8-71dd-a84a-a53d9607d535",
        "storage_key": "property/6737460151192625/019e60db-59a8-71dd-a84a-a53d9607d535.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish open-concept living and dining area adjacent to a contemporary kitchen, perfect for entertaining.",
      "link": "",
      "alt_text": "Modern living room and kitchen area with dining table",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_44afcf7a-c680-46a3-8d65-47c1b18487db",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60db-55d7-7628-ac54-57f40c736449.webp",
      "image_media": {
        "alt_text": "Dining area with table and chairs, next to a kitchen.",
        "public_id": "019e60db-55d7-7628-ac54-57f40c736449",
        "storage_key": "property/6737460151192625/019e60db-55d7-7628-ac54-57f40c736449.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright dining area with a round table set for four, adjacent to a modern kitchen featuring black appliances.",
      "link": "",
      "alt_text": "Dining area with table and chairs, next to a kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d6db287f-b780-474c-826a-5332d957ad0f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60db-3d45-73e9-a66c-4770dec4e4c7.webp",
      "image_media": {
        "alt_text": "Queen-size bed with white and gray striped comforter and teal accent pillows, nightstand with lamp, and closet with stored pillows and hangers.",
        "public_id": "019e60db-3d45-73e9-a66c-4770dec4e4c7",
        "storage_key": "property/6737460151192625/019e60db-3d45-73e9-a66c-4770dec4e4c7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a plush queen-size bed, a stylish nightstand with a lamp, and a spacious closet. Perfect for a relaxing retreat.",
      "link": "",
      "alt_text": "Queen-size bed with white and gray striped comforter and teal accent pillows, nightstand with lamp, and closet with stored pillows and hangers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7a2e043c-fddc-451e-b95f-befc7207eb72",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60db-41b8-72f9-9045-3061e0bb6873.webp",
      "image_media": {
        "alt_text": "A cozy bedroom with a queen-size bed, ceiling fan, and a nightstand with a lamp.",
        "public_id": "019e60db-41b8-72f9-9045-3061e0bb6873",
        "storage_key": "property/6737460151192625/019e60db-41b8-72f9-9045-3061e0bb6873.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in comfort in this well-appointed bedroom, featuring a plush queen-size bed, a modern ceiling fan for optimal air circulation, and a stylish nightstand with ambient lighting.",
      "link": "",
      "alt_text": "A cozy bedroom with a queen-size bed, ceiling fan, and a nightstand with a lamp.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ac24bb71-2b07-4585-bc6f-9d0c928866e7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60db-30de-70cf-8894-67420b65c51c.webp",
      "image_media": {
        "alt_text": "Bedroom with a ceiling fan, dresser, and mirror.",
        "public_id": "019e60db-30de-70cf-8894-67420b65c51c",
        "storage_key": "property/6737460151192625/019e60db-30de-70cf-8894-67420b65c51c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a ceiling fan, a modern dresser with a round mirror, and a comfortable bed.",
      "link": "",
      "alt_text": "Bedroom with a ceiling fan, dresser, and mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7841556c-9cd4-4742-bb8c-d8b7b54f1fa9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019fb353-d103-74ed-8e55-8cf4511580f9.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, ceiling fan, and decorative wall art.",
        "public_id": "019fb353-d103-74ed-8e55-8cf4511580f9",
        "storage_key": "property/6737460151192625/019fb353-d103-74ed-8e55-8cf4511580f9.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Stylish bedroom featuring a comfortable king-size bed, a modern ceiling fan, and elegant wall decor. A cozy accent chair and dresser complete the serene atmosphere.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, ceiling fan, and decorative wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_817cacc9-f504-416d-9fd8-2e4d111b882b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019fb353-bb96-7658-80aa-e519d84bb545.webp",
      "image_media": {
        "alt_text": "Toilet and shower with a decorative curtain in a neutral-toned bathroom.",
        "public_id": "019fb353-bb96-7658-80aa-e519d84bb545",
        "storage_key": "property/6737460151192625/019fb353-bb96-7658-80aa-e519d84bb545.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a toilet and a shower with a stylish curtain. Neutral colors and decorative accents create a clean and inviting space.",
      "link": "",
      "alt_text": "Toilet and shower with a decorative curtain in a neutral-toned bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6624689b-e7d4-45c6-99a1-4090a9f47884",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60db-3af1-73cf-9541-13a857d05dc7.webp",
      "image_media": {
        "alt_text": "Empty living room with gray walls and wood-look flooring, opening to a kitchen.",
        "public_id": "019e60db-3af1-73cf-9541-13a857d05dc7",
        "storage_key": "property/6737460151192625/019e60db-3af1-73cf-9541-13a857d05dc7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and bright living area with modern wood-look flooring and an open kitchen pass-through.",
      "link": "",
      "alt_text": "Empty living room with gray walls and wood-look flooring, opening to a kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e48b9e9f-60bb-48f6-844f-e890ce4f1829",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60db-2759-72c9-9db1-a44e34599635.webp",
      "image_media": {
        "alt_text": "Courtyard with a decorative water feature and bridge, surrounded by apartment buildings.",
        "public_id": "019e60db-2759-72c9-9db1-a44e34599635",
        "storage_key": "property/6737460151192625/019e60db-2759-72c9-9db1-a44e34599635.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the serene courtyard featuring a beautiful water feature with a charming bridge, creating a tranquil ambiance amidst the apartment buildings.",
      "link": "",
      "alt_text": "Courtyard with a decorative water feature and bridge, surrounded by apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9b904b1e-ffa3-4191-8252-7e363c4fd49d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60db-2fca-7183-8030-2edcf1f3ec5c.webp",
      "image_media": {
        "alt_text": "Modern bathroom vanity with gray cabinets, white countertop, sink, and mirror.",
        "public_id": "019e60db-2fca-7183-8030-2edcf1f3ec5c",
        "storage_key": "property/6737460151192625/019e60db-2fca-7183-8030-2edcf1f3ec5c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Refresh and unwind in this stylish bathroom featuring a modern vanity with ample counter space and storage.",
      "link": "",
      "alt_text": "Modern bathroom vanity with gray cabinets, white countertop, sink, and mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6232054e-d8db-43b2-b3a4-6a687355894d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60db-281d-71cd-b3e3-28e7020d651e.webp",
      "image_media": {
        "alt_text": "Charming courtyard with a decorative bridge over a serene water feature, surrounded by lush greenery and brick apartment buildings.",
        "public_id": "019e60db-281d-71cd-b3e3-28e7020d651e",
        "storage_key": "property/6737460151192625/019e60db-281d-71cd-b3e3-28e7020d651e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Discover a tranquil oasis in our community courtyard, featuring a picturesque bridge and a relaxing water feature, all nestled within beautifully maintained landscaping and charming brick buildings.",
      "link": "",
      "alt_text": "Charming courtyard with a decorative bridge over a serene water feature, surrounded by lush greenery and brick apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_951d20eb-6cb3-48e7-b14c-cf2cd561bd4f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60db-2444-7296-952a-cc8f89fdffaa.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a king-sized bed, plush bedding, and decorative pillows.",
        "public_id": "019e60db-2444-7296-952a-cc8f89fdffaa",
        "storage_key": "property/6737460151192625/019e60db-2444-7296-952a-cc8f89fdffaa.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a king-sized bed with luxurious bedding and elegant decorative pillows.",
      "link": "",
      "alt_text": "Cozy bedroom with a king-sized bed, plush bedding, and decorative pillows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c277af0d-2f0b-4873-ba4f-24b331a55bb7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60db-1358-7794-ab44-7d534eab0fc6.webp",
      "image_media": {
        "alt_text": "Kitchen with black refrigerator, microwave, oven, double sink, and cabinets.",
        "public_id": "019e60db-1358-7794-ab44-7d534eab0fc6",
        "storage_key": "property/6737460151192625/019e60db-1358-7794-ab44-7d534eab0fc6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring modern appliances including a refrigerator, microwave, and oven, complemented by a double sink and ample cabinet storage.",
      "link": "",
      "alt_text": "Kitchen with black refrigerator, microwave, oven, double sink, and cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8803e9ea-2055-41fc-9373-f094bb9b0684",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60db-115b-749a-85d7-3ca659ca4ed1.webp",
      "image_media": {
        "alt_text": "Living room with a white door, window with blinds, a floor mirror, and a basket. The kitchen area is visible in the background.",
        "public_id": "019e60db-115b-749a-85d7-3ca659ca4ed1",
        "storage_key": "property/6737460151192625/019e60db-115b-749a-85d7-3ca659ca4ed1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area with modern gray wood flooring, leading into a kitchen with wood cabinets and a breakfast bar. Perfect for comfortable living.",
      "link": "",
      "alt_text": "Living room with a white door, window with blinds, a floor mirror, and a basket. The kitchen area is visible in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_011d64b2-4dfa-4c11-b20f-bc13c784c6b9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60da-ffce-732f-b55f-49c9880e3df8.webp",
      "image_media": {
        "alt_text": "Bathroom with a vanity, toilet, and shower curtain.",
        "public_id": "019e60da-ffce-732f-b55f-49c9880e3df8",
        "storage_key": "property/6737460151192625/019e60da-ffce-732f-b55f-49c9880e3df8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A clean and well-lit bathroom featuring a vanity with a sink, a toilet, and a decorative shower curtain.",
      "link": "",
      "alt_text": "Bathroom with a vanity, toilet, and shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3f7047b0-3513-43bc-85ba-83427f6ca4bd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60da-f69c-720d-90d9-3c61ac7d8921.webp",
      "image_media": {
        "alt_text": "Playground with slides and climbing structures in a residential community.",
        "public_id": "019e60da-f69c-720d-90d9-3c61ac7d8921",
        "storage_key": "property/6737460151192625/019e60da-f69c-720d-90d9-3c61ac7d8921.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at the community playground, featuring slides and climbing structures for children.",
      "link": "",
      "alt_text": "Playground with slides and climbing structures in a residential community.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f9b70fa3-f7ed-4005-b9c4-e616f45c08d5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60da-f3e8-73df-b4dd-9233c553ffc2.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with grills and tables under a pergola.",
        "public_id": "019e60da-f3e8-73df-b4dd-9233c553ffc2",
        "storage_key": "property/6737460151192625/019e60da-f3e8-73df-b4dd-9233c553ffc2.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings with our communal grill area and shaded seating, perfect for relaxation and socializing.",
      "link": "",
      "alt_text": "Outdoor seating area with grills and tables under a pergola.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3fdec021-72b2-43e0-bd6d-97a5627db088",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60da-f5ce-778a-9a12-fd120a4d12a0.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a covered seating area at a multifamily property.",
        "public_id": "019e60da-f5ce-778a-9a12-fd120a4d12a0",
        "storage_key": "property/6737460151192625/019e60da-f5ce-778a-9a12-fd120a4d12a0.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling swimming pool, featuring comfortable lounge chairs and a shaded cabana perfect for sunny days.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and a covered seating area at a multifamily property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0be54208-a85f-4174-ada2-ee4b7cca6861",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60da-f47c-77c6-9df1-f902ee9ddfcf.webp",
      "image_media": {
        "alt_text": "Baystone Apartments monument sign and building exterior",
        "public_id": "019e60da-f47c-77c6-9df1-f902ee9ddfcf",
        "storage_key": "property/6737460151192625/019e60da-f47c-77c6-9df1-f902ee9ddfcf.webp",
        "width": 2000,
        "height": 1332
      },
      "title": "Community",
      "description": "Exterior view of the Baystone Apartments building with a monument sign and landscaping.",
      "link": "",
      "alt_text": "Baystone Apartments monument sign and building exterior",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_23386723-ce0d-4156-9c3c-1e1ab9e3329a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60da-f0bf-709c-bce3-dc64817a7430.webp",
      "image_media": {
        "alt_text": "Courtyard with a pool and bridge at an apartment complex.",
        "public_id": "019e60da-f0bf-709c-bce3-dc64817a7430",
        "storage_key": "property/6737460151192625/019e60da-f0bf-709c-bce3-dc64817a7430.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy our beautiful outdoor pool and tranquil courtyard area, perfect for relaxing or socializing.",
      "link": "",
      "alt_text": "Courtyard with a pool and bridge at an apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e4515ae3-24a7-4152-88a0-8a3a18bcc9a0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60da-f428-7198-9e83-5bbcfb28f206.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, adjacent to apartment buildings.",
        "public_id": "019e60da-f428-7198-9e83-5bbcfb28f206",
        "storage_key": "property/6737460151192625/019e60da-f428-7198-9e83-5bbcfb28f206.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and lush landscaping. Perfect for soaking up the sun and unwinding after a long day.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, adjacent to apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6fd028d3-8dc7-4431-a66a-aa5c2180f52c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60da-f048-735c-9ceb-73a5733b7c7f.webp",
      "image_media": {
        "alt_text": "Bridge over a water feature with apartments in the background",
        "public_id": "019e60da-f048-735c-9ceb-73a5733b7c7f",
        "storage_key": "property/6737460151192625/019e60da-f048-735c-9ceb-73a5733b7c7f.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Community",
      "description": "Charming bridge crossing a decorative water feature, surrounded by lush landscaping and brick apartment buildings.",
      "link": "",
      "alt_text": "Bridge over a water feature with apartments in the background",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ad9fbc06-4844-4697-ab1a-601b2fc08dad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60da-ee1a-76aa-bcbe-4246f9eacfef.webp",
      "image_media": {
        "alt_text": "Modern lobby with a large staircase and a seating area featuring blue velvet chairs around a geometric coffee table.",
        "public_id": "019e60da-ee1a-76aa-bcbe-4246f9eacfef",
        "storage_key": "property/6737460151192625/019e60da-ee1a-76aa-bcbe-4246f9eacfef.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Step into our inviting community lobby, designed for comfort and style. Enjoy the modern ambiance with ample seating and elegant decor.",
      "link": "",
      "alt_text": "Modern lobby with a large staircase and a seating area featuring blue velvet chairs around a geometric coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_582b49e7-c1ba-42c0-9974-f4b0586e4255",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60da-e7ef-707f-b896-a2e81d7229c5.webp",
      "image_media": {
        "alt_text": "Lobby with blue velvet chairs and a modern fireplace.",
        "public_id": "019e60da-e7ef-707f-b896-a2e81d7229c5",
        "storage_key": "property/6737460151192625/019e60da-e7ef-707f-b896-a2e81d7229c5.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lobby, featuring comfortable seating and a cozy fireplace.",
      "link": "",
      "alt_text": "Lobby with blue velvet chairs and a modern fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5809cb92-9fda-4f2a-b58e-393e328d383a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60da-e1db-72ed-b813-7a6538a9df6b.webp",
      "image_media": {
        "alt_text": "Modern common area with bar seating and lounge chairs",
        "public_id": "019e60da-e1db-72ed-b813-7a6538a9df6b",
        "storage_key": "property/6737460151192625/019e60da-e1db-72ed-b813-7a6538a9df6b.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax and entertain in our stylish common area, featuring a sleek bar with ample seating and comfortable lounge chairs overlooking the scenic outdoors.",
      "link": "",
      "alt_text": "Modern common area with bar seating and lounge chairs",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d5c8acb8-db98-4129-a81d-47eefe3fea45",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60da-e3de-75fd-8650-589e35a79323.webp",
      "image_media": {
        "alt_text": "Comfortable seating area with orange sectional sofa, blue chairs, and tables, overlooking large windows with greenery.",
        "public_id": "019e60da-e3de-75fd-8650-589e35a79323",
        "storage_key": "property/6737460151192625/019e60da-e3de-75fd-8650-589e35a79323.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish and comfortable community lounge, featuring plush seating and ample natural light.",
      "link": "",
      "alt_text": "Comfortable seating area with orange sectional sofa, blue chairs, and tables, overlooking large windows with greenery.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b36393c3-d1fa-480d-a024-2e61c1e5fa39",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60da-e099-7343-84da-dbb95872220a.webp",
      "image_media": {
        "alt_text": "Modern living room with sofa, chair, coffee table, and dining area.",
        "public_id": "019e60da-e099-7343-84da-dbb95872220a",
        "storage_key": "property/6737460151192625/019e60da-e099-7343-84da-dbb95872220a.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Stylish and comfortable living room with a plush sofa, accent chair, and a well-appointed dining area, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Modern living room with sofa, chair, coffee table, and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_147dc3da-8724-41d8-afa4-72c8d24f7e65",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60da-dfea-7109-ad8c-7de8930be7a7.webp",
      "image_media": {
        "alt_text": "Community room with tables and chairs, overlooking the courtyard.",
        "public_id": "019e60da-dfea-7109-ad8c-7de8930be7a7",
        "storage_key": "property/6737460151192625/019e60da-dfea-7109-ad8c-7de8930be7a7.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy a moment of relaxation or casual conversation in our beautifully appointed community room, offering serene courtyard views.",
      "link": "",
      "alt_text": "Community room with tables and chairs, overlooking the courtyard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_64e086d3-f3b2-4541-ab73-726e20064c6f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60da-e59c-713d-a0ed-565ddf9a2b50.webp",
      "image_media": {
        "alt_text": "Modern lounge area with green sofa, fireplace, and bar seating.",
        "public_id": "019e60da-e59c-713d-a0ed-565ddf9a2b50",
        "storage_key": "property/6737460151192625/019e60da-e59c-713d-a0ed-565ddf9a2b50.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring a cozy fireplace, comfortable seating, and a bar area perfect for socializing.",
      "link": "",
      "alt_text": "Modern lounge area with green sofa, fireplace, and bar seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4e2053e2-02c4-46ea-9e85-b6d824c6bb44",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60da-e46e-700a-8aba-6def9aeafb36.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, weight machines, and stationary bikes.",
        "public_id": "019e60da-e46e-700a-8aba-6def9aeafb36",
        "storage_key": "property/6737460151192625/019e60da-e46e-700a-8aba-6def9aeafb36.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring cardio machines and strength training equipment.",
      "link": "",
      "alt_text": "Fitness center with treadmills, ellipticals, weight machines, and stationary bikes.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0a65ec62-6071-495e-aab2-090da5524416",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60da-df1f-77fc-bdfc-34d57f5dfb75.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen with black appliances and gray cabinets",
        "public_id": "019e60da-df1f-77fc-bdfc-34d57f5dfb75",
        "storage_key": "property/6737460151192625/019e60da-df1f-77fc-bdfc-34d57f5dfb75.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Stylish dining area with a white table and chairs, adjacent to a modern kitchen featuring black appliances and ample cabinet space.",
      "link": "",
      "alt_text": "Dining area and kitchen with black appliances and gray cabinets",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a80f5219-b09d-4a58-8e33-9ac34804538c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60da-e1d7-7488-9d2a-d18238cde9f5.webp",
      "image_media": {
        "alt_text": "Fitness center with weight machines, dumbbells, yoga mats, and medicine balls.",
        "public_id": "019e60da-e1d7-7488-9d2a-d18238cde9f5",
        "storage_key": "property/6737460151192625/019e60da-e1d7-7488-9d2a-d18238cde9f5.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Stay active and healthy in our fully equipped fitness center, featuring state-of-the-art cardio and weight training equipment.",
      "link": "",
      "alt_text": "Fitness center with weight machines, dumbbells, yoga mats, and medicine balls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7b09b231-95d2-4ce4-86e2-2ebb52af2909",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60da-db8c-71c9-9ef7-118103a0b330.webp",
      "image_media": {
        "alt_text": "Black refrigerator and stove in a kitchen with light gray cabinets and white countertops.",
        "public_id": "019e60da-db8c-71c9-9ef7-118103a0b330",
        "storage_key": "property/6737460151192625/019e60da-db8c-71c9-9ef7-118103a0b330.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Upgrade your cooking experience in this beautifully designed kitchen, featuring a sleek black refrigerator and stove complemented by light gray cabinetry and clean white countertops.",
      "link": "",
      "alt_text": "Black refrigerator and stove in a kitchen with light gray cabinets and white countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_52485f38-c9e2-4e14-b305-53a54b3b9478",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60da-d11e-771b-a716-b727dc0e6f31.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink, mirror, and a glimpse of a bedroom.",
        "public_id": "019e60da-d11e-771b-a716-b727dc0e6f31",
        "storage_key": "property/6737460151192625/019e60da-d11e-771b-a716-b727dc0e6f31.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Modern bathroom vanity featuring a white sink and countertop, a large mirror with vanity lights, and decorative accents. A doorway in the background reveals a neatly made bed in the bedroom.",
      "link": "",
      "alt_text": "Bathroom vanity with sink, mirror, and a glimpse of a bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e4d33b99-4382-44d9-8878-f78f8b3343a8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60da-d10b-70a9-9589-ecdd35f22d1a.webp",
      "image_media": {
        "alt_text": "A stylish bedroom with a queen-size bed, modern artwork, and a ceiling fan. Features a closet and an en suite bathroom.",
        "public_id": "019e60da-d10b-70a9-9589-ecdd35f22d1a",
        "storage_key": "property/6737460151192625/019e60da-d10b-70a9-9589-ecdd35f22d1a.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed bedroom, complete with a plush queen-size bed, elegant decor, and a convenient en suite bathroom. Your perfect retreat awaits.",
      "link": "",
      "alt_text": "A stylish bedroom with a queen-size bed, modern artwork, and a ceiling fan. Features a closet and an en suite bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c7d3415b-2c28-41c4-bf2f-db73dd9c7010",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60da-d58e-774d-97dd-6049101badad.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-sized bed, ceiling fan, and nightstand.",
        "public_id": "019e60da-d58e-774d-97dd-6049101badad",
        "storage_key": "property/6737460151192625/019e60da-d58e-774d-97dd-6049101badad.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush queen-sized bed, modern ceiling fan, and a stylish nightstand.",
      "link": "",
      "alt_text": "Bedroom with a queen-sized bed, ceiling fan, and nightstand.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0ef47c11-6bfa-4d84-8e0f-b19a38371c74",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60da-d011-72fe-a11f-6a5f768b6082.webp",
      "image_media": {
        "alt_text": "Stylish bedroom with a king-size bed and decorative wall art.",
        "public_id": "019e60da-d011-72fe-a11f-6a5f768b6082",
        "storage_key": "property/6737460151192625/019e60da-d011-72fe-a11f-6a5f768b6082.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed bedroom, featuring a plush king-size bed and tasteful decor.",
      "link": "",
      "alt_text": "Stylish bedroom with a king-size bed and decorative wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_45c44c60-aa74-4295-a4aa-21a2fd3f3da6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60da-cfca-747a-907a-54fa76b2b7c5.webp",
      "image_media": {
        "alt_text": "A bedroom featuring a king-size bed with white bedding and decorative pillows, a blue headboard, a ceiling fan, and an open closet.",
        "public_id": "019e60da-cfca-747a-907a-54fa76b2b7c5",
        "storage_key": "property/6737460151192625/019e60da-cfca-747a-907a-54fa76b2b7c5.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, complete with a plush king-size bed and ample closet space.",
      "link": "",
      "alt_text": "A bedroom featuring a king-size bed with white bedding and decorative pillows, a blue headboard, a ceiling fan, and an open closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c7235cc9-d2b8-4eec-8975-5a3f2cda22f3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60da-cbd3-70b1-a018-b0621713f884.webp",
      "image_media": {
        "alt_text": "A spacious bedroom featuring a king-size bed, a modern dresser, a ceiling fan, and a walk-in closet.",
        "public_id": "019e60da-cbd3-70b1-a018-b0621713f884",
        "storage_key": "property/6737460151192625/019e60da-cbd3-70b1-a018-b0621713f884.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, complete with a plush king-size bed, ample storage with a stylish dresser, and a convenient walk-in closet.",
      "link": "",
      "alt_text": "A spacious bedroom featuring a king-size bed, a modern dresser, a ceiling fan, and a walk-in closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e77bc66a-2dc5-46ad-9feb-003ef1359a7d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60da-cb4b-7508-a253-c096aa7c4152.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with a refrigerator and cabinets.",
        "public_id": "019e60da-cb4b-7508-a253-c096aa7c4152",
        "storage_key": "property/6737460151192625/019e60da-cb4b-7508-a253-c096aa7c4152.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious living room and open-concept kitchen featuring modern finishes and ample cabinet space.",
      "link": "",
      "alt_text": "Living room and kitchen area with a refrigerator and cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e6ef5fc8-fcd5-413f-98d1-6bd1a810f09c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60da-c8fd-74ce-a3c6-0082ffec8cb8.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and courtyard area surrounded by apartment buildings.",
        "public_id": "019e60da-c8fd-74ce-a3c6-0082ffec8cb8",
        "storage_key": "property/6737460151192625/019e60da-c8fd-74ce-a3c6-0082ffec8cb8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor pool, surrounded by lush landscaping and beautiful apartment buildings.",
      "link": "",
      "alt_text": "Outdoor swimming pool and courtyard area surrounded by apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_013a77de-9545-4362-81b5-2223dc61872b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60da-c92a-759f-8748-b4115fc7f2dd.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with gray walls and wood-look flooring.",
        "public_id": "019e60da-c92a-759f-8748-b4115fc7f2dd",
        "storage_key": "property/6737460151192625/019e60da-c92a-759f-8748-b4115fc7f2dd.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious living room and kitchen area featuring modern gray walls and stylish wood-look flooring, perfect for comfortable living.",
      "link": "",
      "alt_text": "Living room and kitchen area with gray walls and wood-look flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_aa29d812-9b92-4485-b34b-805b9c031b97",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60da-bf58-77d1-b114-272908ba66d6.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019e60da-bf58-77d1-b114-272908ba66d6",
        "storage_key": "property/6737460151192625/019e60da-bf58-77d1-b114-272908ba66d6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and lush greenery. A perfect oasis for residents.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cbaf5ba3-2e71-4ce5-b95e-ad9f5ada2a75",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60da-b145-7400-b83c-477d4e444201.webp",
      "image_media": {
        "alt_text": "Outdoor patio with seating and grilling area next to pool.",
        "public_id": "019e60da-b145-7400-b83c-477d4e444201",
        "storage_key": "property/6737460151192625/019e60da-b145-7400-b83c-477d4e444201.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and entertain in the outdoor lounge area, complete with comfortable seating, a grilling station, and a sparkling swimming pool.",
      "link": "",
      "alt_text": "Outdoor patio with seating and grilling area next to pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6704f8fb-6e57-4ac3-a668-ac63b6e28566",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60da-b25e-74f6-9d3a-1b9bff8f6cd5.webp",
      "image_media": {
        "alt_text": "Aerial view of a tranquil courtyard with a winding water feature and lush landscaping.",
        "public_id": "019e60da-b25e-74f6-9d3a-1b9bff8f6cd5",
        "storage_key": "property/6737460151192625/019e60da-b25e-74f6-9d3a-1b9bff8f6cd5.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Community",
      "description": "Discover resort-style living with our beautifully landscaped courtyard, featuring a serene water feature and walking paths.",
      "link": "",
      "alt_text": "Aerial view of a tranquil courtyard with a winding water feature and lush landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2d931976-0a97-4b5c-9535-f11f71f7072e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60da-b17d-70cf-95f3-5f28a5f5fba9.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool and spa with lounge chairs and umbrellas.",
        "public_id": "019e60da-b17d-70cf-95f3-5f28a5f5fba9",
        "storage_key": "property/6737460151192625/019e60da-b17d-70cf-95f3-5f28a5f5fba9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool and relax on the sundeck. Perfect for a sunny afternoon.",
      "link": "",
      "alt_text": "Resort-style swimming pool and spa with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3a0c81f3-6490-456d-8748-cc9c53bdc2d4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60da-ac27-75ba-8437-458a865fdb22.webp",
      "image_media": {
        "alt_text": "Aerial view of a swimming pool area with lounge chairs and a covered patio with tables.",
        "public_id": "019e60da-ac27-75ba-8437-458a865fdb22",
        "storage_key": "property/6737460151192625/019e60da-ac27-75ba-8437-458a865fdb22.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and a shaded patio area perfect for relaxing.",
      "link": "",
      "alt_text": "Aerial view of a swimming pool area with lounge chairs and a covered patio with tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5b15c053-975b-4013-b11a-d9805dbe4a01",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60da-a888-77e9-b5d6-d3e2c336f00d.webp",
      "image_media": {
        "alt_text": "Aerial view of a community courtyard with a unique-shaped swimming pool, lush landscaping, and walking paths.",
        "public_id": "019e60da-a888-77e9-b5d6-d3e2c336f00d",
        "storage_key": "property/6737460151192625/019e60da-a888-77e9-b5d6-d3e2c336f00d.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Discover the vibrant community at our property, featuring a uniquely designed swimming pool, beautifully landscaped courtyards, and scenic walking paths for resident enjoyment.",
      "link": "",
      "alt_text": "Aerial view of a community courtyard with a unique-shaped swimming pool, lush landscaping, and walking paths.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_05767f86-c706-4cbb-a855-f2f6c784a2f1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60da-a3ee-742c-b853-d775500c9f2f.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019e60da-a3ee-742c-b853-d775500c9f2f",
        "storage_key": "property/6737460151192625/019e60da-a3ee-742c-b853-d775500c9f2f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and shaded seating areas for ultimate relaxation.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_40e3f2f5-3b64-4c6d-bfd7-5ecd0e827b33",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e60da-a2ed-72c8-96d2-e851b8359da4.webp",
      "image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool and spa area surrounded by lounge chairs and umbrellas.",
        "public_id": "019e60da-a2ed-72c8-96d2-e851b8359da4",
        "storage_key": "property/6737460151192625/019e60da-a2ed-72c8-96d2-e851b8359da4.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool and spa, complete with comfortable lounge seating and shaded umbrellas. Perfect for relaxation and soaking up the sun.",
      "link": "",
      "alt_text": "Aerial view of an outdoor swimming pool and spa area surrounded by lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8953f6be-d8d6-4c52-a88d-6e7f59a301a1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019fb353-bb83-7333-9101-f38fa36bc12b.webp",
      "image_media": {
        "alt_text": "Modern living and dining area with a tan armchair, coffee table, dining set, and a view into the kitchen.",
        "public_id": "019fb353-bb83-7333-9101-f38fa36bc12b",
        "storage_key": "property/6737460151192625/019fb353-bb83-7333-9101-f38fa36bc12b.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this inviting living and dining area, complete with a chic tan armchair, elegant coffee table, and a glimpse into the modern kitchen.",
      "link": "",
      "alt_text": "Modern living and dining area with a tan armchair, coffee table, dining set, and a view into the kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5b7513f4-d286-45a6-872a-7bc9f0904905",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019fb353-ba6b-7449-abc4-21393aa2ca95.webp",
      "image_media": {
        "alt_text": "Modern kitchen with grey cabinets and stainless steel sink opens to a living area with a sofa, armchair, and ceiling fan.",
        "public_id": "019fb353-ba6b-7449-abc4-21393aa2ca95",
        "storage_key": "property/6737460151192625/019fb353-ba6b-7449-abc4-21393aa2ca95.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Step into this inviting apartment featuring a sleek grey kitchen with ample cabinet space, flowing seamlessly into a comfortable living area. Perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with grey cabinets and stainless steel sink opens to a living area with a sofa, armchair, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_a1f6ac60-999c-4819-9af7-8361ca3e8143",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Hyde Park",
      "poi_type": "Restaurants",
      "poi_address": "247 E NASA Pkwy, Webster, TX 77598, USA",
      "poi_short_description": "Easygoing choice with a low-key vibe offering burgers & pasta, plus pizza from a wood-fired oven.",
      "poi_long_description": "Easygoing choice with a low-key vibe offering burgers & pasta, plus pizza from a wood-fired oven.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-7e0d-7136-aa4a-8fbec8635007.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-7e0d-7136-aa4a-8fbec8635007",
        "storage_key": "property/6737460151192625/019e1dfc-7e0d-7136-aa4a-8fbec8635007.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://hydeparknasa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11030620326859214493&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hyde-park",
      "poi_latitude": "29.5392798",
      "poi_longitude": "-95.1167945",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 832-932-5768",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-5089-748b-8c54-a184424bfd66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-5089-748b-8c54-a184424bfd66",
        "storage_key": "property/6737460151192625/019e1dfa-5089-748b-8c54-a184424bfd66.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJg4Xfi7CdQIYRnY6lmr6iFJk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_c660ca05-cc5b-4d32-bea4-4ced1c503758",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Saloon Door Brewing",
      "poi_type": "Restaurants",
      "poi_address": "105 A Magellan Cir, Webster, TX 77598, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-745e-7224-b09d-10d4c0de8563.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-745e-7224-b09d-10d4c0de8563",
        "storage_key": "property/6737460151192625/019e1dfc-745e-7224-b09d-10d4c0de8563.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.saloondoorbrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1486922207096219692&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saloon-door-brewing",
      "poi_latitude": "29.5268534",
      "poi_longitude": "-95.1190335",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 281-332-5800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-5086-7098-aa85-b0ce772a582e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-5086-7098-aa85-b0ce772a582e",
        "storage_key": "property/6737460151192625/019e1dfa-5086-7098-aa85-b0ce772a582e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfeeUtcGcQIYRLCicit6bohQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "custom_10cf8f8e-7bff-4e5d-8f5e-045b6667a065",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Perry's Steakhouse & Grille",
      "poi_type": "Restaurants",
      "poi_address": "700 Baybrook Mall, Friendswood, TX 77546, USA",
      "poi_short_description": "Upscale steakhouse & grill serving a menu including chops, seafood, wine & cocktails.",
      "poi_long_description": "Upscale steakhouse & grill serving a menu including chops, seafood, wine & cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-7cd7-77a4-9c87-f481f9ea8a45.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-7cd7-77a4-9c87-f481f9ea8a45",
        "storage_key": "property/6737460151192625/019e1dfc-7cd7-77a4-9c87-f481f9ea8a45.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.perryssteakhouse.com/menu-locations/houston/baybrook/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8369159261860252057&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "perrys-steakhouse--grille",
      "poi_latitude": "29.5463465",
      "poi_longitude": "-95.1493868",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 281-286-8800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-5089-748b-8c54-a184424bfd66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-5089-748b-8c54-a184424bfd66",
        "storage_key": "property/6737460151192625/019e1dfa-5089-748b-8c54-a184424bfd66.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJl6jYG4qcQIYRmcnZxwE6JXQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_8c3ac87c-1330-49bf-8524-30aabc5607a0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Pappas Seafood House",
      "poi_type": "Restaurants",
      "poi_address": "19991 I-45, Webster, TX 77598, USA",
      "poi_short_description": "Seafood classics fried & grilled, plus other regional favorites like gumbo in a laid-back setting.",
      "poi_long_description": "Seafood classics fried & grilled, plus other regional favorites like gumbo in a laid-back setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-74ba-776c-a229-0c7093c5747d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-74ba-776c-a229-0c7093c5747d",
        "storage_key": "property/6737460151192625/019e1dfc-74ba-776c-a229-0c7093c5747d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://pappasseafood.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12599411386338288524&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pappas-seafood-house",
      "poi_latitude": "29.5365612",
      "poi_longitude": "-95.1368952",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 281-332-7546",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-5089-748b-8c54-a184424bfd66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-5089-748b-8c54-a184424bfd66",
        "storage_key": "property/6737460151192625/019e1dfa-5089-748b-8c54-a184424bfd66.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2YeAdpucQIYRjKO0veYZ2q4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_9b5a2186-a774-4b1a-984e-bd0d1165ec1b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Floyd's Seafood - Webster",
      "poi_type": "Restaurants",
      "poi_address": "20760 Gulf Fwy, Webster, TX 77598, USA",
      "poi_short_description": "1 of a chain serving seafood, steak & Louisiana-style eats in barlike environs with live music.",
      "poi_long_description": "1 of a chain serving seafood, steak & Louisiana-style eats in barlike environs with live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-89b6-72a5-b16f-90d1db3862e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-89b6-72a5-b16f-90d1db3862e5",
        "storage_key": "property/6737460151192625/019e1dfc-89b6-72a5-b16f-90d1db3862e5.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.floydsseafood.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2958864555940783641&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "floyds-seafood---webster",
      "poi_latitude": "29.5265902",
      "poi_longitude": "-95.1297945",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 281-332-7474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-5089-748b-8c54-a184424bfd66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-5089-748b-8c54-a184424bfd66",
        "storage_key": "property/6737460151192625/019e1dfa-5089-748b-8c54-a184424bfd66.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7Vxgn72cQIYRGSZYC6P_Dyk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_73afe856-0a9b-4dbb-8ae2-05125348f0e5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "BoomerJack's Grill",
      "poi_type": "Restaurants",
      "poi_address": "20961 Gulf Fwy, Webster, TX 77598, USA",
      "poi_short_description": "Branch of a local chain known for beer, burgers & other pub grub, with a patio & sports on many TVs.",
      "poi_long_description": "Branch of a local chain known for beer, burgers & other pub grub, with a patio & sports on many TVs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-7844-708b-9c2d-409d6dfcf560.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-7844-708b-9c2d-409d6dfcf560",
        "storage_key": "property/6737460151192625/019e1dfc-7844-708b-9c2d-409d6dfcf560.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://boomerjacks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8061713107903563057&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boomerjacks-grill",
      "poi_latitude": "29.5241134",
      "poi_longitude": "-95.1255043",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 281-768-2649",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-c47e-77ef-b6e4-f04d43773bed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfc-c47e-77ef-b6e4-f04d43773bed",
        "storage_key": "property/6737460151192625/019e1dfc-c47e-77ef-b6e4-f04d43773bed.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMUi-3MudQIYRMcWz3Vv14G8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_718b4bf5-09d3-423d-926a-c6c202431349",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Mamacita's",
      "poi_type": "Restaurants",
      "poi_address": "515 E Nasa Rd 1, Webster, TX 77598, USA",
      "poi_short_description": "Branch of Mexican chain offering 3 meals a day, including early-bird dinner specials, & a full bar.",
      "poi_long_description": "Branch of Mexican chain offering 3 meals a day, including early-bird dinner specials, & a full bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-8005-7578-8817-bd81fa39e820.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-8005-7578-8817-bd81fa39e820",
        "storage_key": "property/6737460151192625/019e1dfc-8005-7578-8817-bd81fa39e820.webp",
        "width": 1280,
        "height": 778
      },
      "poi_business_url": "https://mamacitashouston.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14876185986801088625&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mamacitas",
      "poi_latitude": "29.5415065",
      "poi_longitude": "-95.1139361",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-332-5362",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-5089-748b-8c54-a184424bfd66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-5089-748b-8c54-a184424bfd66",
        "storage_key": "property/6737460151192625/019e1dfa-5089-748b-8c54-a184424bfd66.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJIYC_FfCcQIYRcTjsa1bUcs4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_17b6db7f-e01c-478a-a4c9-614c05da034c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "IHOP",
      "poi_type": "Restaurants",
      "poi_address": "803 E NASA Pkwy, Webster, TX 77598, USA",
      "poi_short_description": "Long-standing chain serving a wide variety of pancakes & other American breakfast & diner fare.",
      "poi_long_description": "Long-standing chain serving a wide variety of pancakes & other American breakfast & diner fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-7384-754a-beeb-e74e2780f9fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-7384-754a-beeb-e74e2780f9fb",
        "storage_key": "property/6737460151192625/019e1dfc-7384-754a-beeb-e74e2780f9fb.webp",
        "width": 1200,
        "height": 900
      },
      "poi_business_url": "https://restaurants.ihop.com/en-us/tx/webster/breakfast-803-e-nasa-pkwy-1430?utm_source=google&utm_medium=organic&utm_campaign=google_my_business&utm_term=1430&utm_content=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=1830894053938722786&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ihop",
      "poi_latitude": "29.5449714",
      "poi_longitude": "-95.1088721",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-282-9253",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-5089-748b-8c54-a184424bfd66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-5089-748b-8c54-a184424bfd66",
        "storage_key": "property/6737460151192625/019e1dfa-5089-748b-8c54-a184424bfd66.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ73OptvucQIYR4ndkCnGkaBk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_a0556924-fccd-4f13-b4a5-38c6d4aeeff1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Whataburger",
      "poi_type": "Restaurants",
      "poi_address": "100 NASA Road 1, Webster, TX 77598, USA",
      "poi_short_description": "Circa-1950 fast-food chain for counter-serve burgers, some stacked with multiple patties.",
      "poi_long_description": "Circa-1950 fast-food chain for counter-serve burgers, some stacked with multiple patties.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-7388-74b9-a35c-48a47958cd2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-7388-74b9-a35c-48a47958cd2a",
        "storage_key": "property/6737460151192625/019e1dfc-7388-74b9-a35c-48a47958cd2a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.whataburger.com/tx/webster/100-w-nasa-rd-1.html/?utm_source=yextpages&utm_medium=locallistings&utm_campaign=yextpages",
      "poi_directions_map_url": "https://maps.google.com/?cid=2800195816744552984&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whataburger",
      "poi_latitude": "29.5374388",
      "poi_longitude": "-95.1189313",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 281-338-1576",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-5089-748b-8c54-a184424bfd66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-5089-748b-8c54-a184424bfd66",
        "storage_key": "property/6737460151192625/019e1dfa-5089-748b-8c54-a184424bfd66.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_4xise2cQIYRGAqYXkJL3CY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_ff181634-68dc-420b-9972-eb1da64181bc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "East Star Chinese Buffet",
      "poi_type": "Restaurants",
      "poi_address": "1025 E NASA Pkwy, Houston, TX 77058, USA",
      "poi_short_description": "Spacious restaurant offering rows of Asian buffet items from sushi & noodles to crawfish & crab.",
      "poi_long_description": "Spacious restaurant offering rows of Asian buffet items from sushi & noodles to crawfish & crab.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-7912-7117-b5c8-05b785bf1bed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-7912-7117-b5c8-05b785bf1bed",
        "storage_key": "property/6737460151192625/019e1dfc-7912-7117-b5c8-05b785bf1bed.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13350310116338947493&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "east-star-chinese-buffet",
      "poi_latitude": "29.5467433",
      "poi_longitude": "-95.1060791",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-280-8822",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-5089-748b-8c54-a184424bfd66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-5089-748b-8c54-a184424bfd66",
        "storage_key": "property/6737460151192625/019e1dfa-5089-748b-8c54-a184424bfd66.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ80GOoP6cQIYRpdWvXVHURbk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_d10f9bb6-d07d-40e7-9cd8-6035f4e55689",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Stomp's Burger Joint",
      "poi_type": "Restaurants",
      "poi_address": "300 W Bay Area Blvd Suite 800, Webster, TX 77598, USA",
      "poi_short_description": "Family-friendly eatery with a Texas theme serving burgers, fries and milkshakes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-8318-7690-86bb-314b4f5a1ba5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-8318-7690-86bb-314b4f5a1ba5",
        "storage_key": "property/6737460151192625/019e1dfc-8318-7690-86bb-314b4f5a1ba5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.stompsburgerjoint.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9695157437546726829&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stomps-burger-joint",
      "poi_latitude": "29.5478823",
      "poi_longitude": "-95.1309467",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-724-9297",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-5089-748b-8c54-a184424bfd66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-5089-748b-8c54-a184424bfd66",
        "storage_key": "property/6737460151192625/019e1dfa-5089-748b-8c54-a184424bfd66.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXY9_PlOdQIYRrYV1glIejIY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_1920089f-303e-4cdd-92d2-19b54877eaf4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Hash Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "1065 W Bay Area Blvd ste 170, Webster, TX 77598, USA",
      "poi_short_description": "Lively place for creative brunch fare, Bloody Marys and cocktails, as well as craft coffee.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-8906-7241-8d7a-785a26501cac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-8906-7241-8d7a-785a26501cac",
        "storage_key": "property/6737460151192625/019e1dfc-8906-7241-8d7a-785a26501cac.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://hashkitchen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15366081825233738&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hash-kitchen",
      "poi_latitude": "29.5406601",
      "poi_longitude": "-95.13979820000002",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-406-3427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-5089-748b-8c54-a184424bfd66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-5089-748b-8c54-a184424bfd66",
        "storage_key": "property/6737460151192625/019e1dfa-5089-748b-8c54-a184424bfd66.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJIf5dVwCdQIYRSlvIuF6XNgA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_71830516-854d-4477-a2b8-aa4d02837a05",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Snooze, an A.M. Eatery",
      "poi_type": "Restaurants",
      "poi_address": "820 W Bay Area Blvd #100, Webster, TX 77598, USA",
      "poi_short_description": "Vibrant, retro chain serving a seasonal menu of creative breakfast & lunch fare, plus cocktails.",
      "poi_long_description": "Vibrant, retro chain serving a seasonal menu of creative breakfast & lunch fare, plus cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-82ca-7168-9d99-c713a3a9b3d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-82ca-7168-9d99-c713a3a9b3d7",
        "storage_key": "property/6737460151192625/019e1dfc-82ca-7168-9d99-c713a3a9b3d7.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.snoozeeatery.com/restaurant/texas/clear-lake/?utm_source=Google&utm_medium=BusinessListing",
      "poi_directions_map_url": "https://maps.google.com/?cid=561971669780874740&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "snooze-an-am-eatery",
      "poi_latitude": "29.5439833",
      "poi_longitude": "-95.136321",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 346-230-4883",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-5089-748b-8c54-a184424bfd66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-5089-748b-8c54-a184424bfd66",
        "storage_key": "property/6737460151192625/019e1dfa-5089-748b-8c54-a184424bfd66.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQdIPLgadQIYR9EUfl0GGzAc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_13165d2e-b64a-443d-84b7-066b38606a99",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Kura Revolving Sushi Bar",
      "poi_type": "Restaurants",
      "poi_address": "1065 W Bay Area Blvd Suite 230, Webster, TX 77598, USA",
      "poi_short_description": "Buzzy eatery serving sushi, udon noodles and tempura dishes, all delivered via conveyor belt.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-88aa-75d0-8218-53c62816ce55.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-88aa-75d0-8218-53c62816ce55",
        "storage_key": "property/6737460151192625/019e1dfc-88aa-75d0-8218-53c62816ce55.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kurasushi.com/locations/webster-tx",
      "poi_directions_map_url": "https://maps.google.com/?cid=17885117612067389481&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kura-revolving-sushi-bar",
      "poi_latitude": "29.5403838",
      "poi_longitude": "-95.1399294",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 281-944-7878",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-5089-748b-8c54-a184424bfd66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-5089-748b-8c54-a184424bfd66",
        "storage_key": "property/6737460151192625/019e1dfa-5089-748b-8c54-a184424bfd66.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSY4EEgCdQIYRKQBccbWzNPg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_9c45630d-cef1-4417-9def-6118b948bf64",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Pho Barr",
      "poi_type": "Restaurants",
      "poi_address": "803 E NASA Pkwy #148, Webster, TX 77598, USA",
      "poi_short_description": "Artful, chic space turning out noodle soups, sandwiches & other Vietnamese street food.",
      "poi_long_description": "Artful, chic space turning out noodle soups, sandwiches & other Vietnamese street food.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-8905-70b4-9047-21e069e278fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-8905-70b4-9047-21e069e278fc",
        "storage_key": "property/6737460151192625/019e1dfc-8905-70b4-9047-21e069e278fc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://phobarr.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6567942084935172261&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pho-barr",
      "poi_latitude": "29.5454934",
      "poi_longitude": "-95.1093292",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 346-230-7988",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-5089-748b-8c54-a184424bfd66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-5089-748b-8c54-a184424bfd66",
        "storage_key": "property/6737460151192625/019e1dfa-5089-748b-8c54-a184424bfd66.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJG6tgUYKdQIYRpUDmHYcEJls",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_24eeaede-5d80-4994-b1fc-70fff3c8d820",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Nasa Foodmart",
      "poi_type": "Shopping & Retail",
      "poi_address": "4024 NASA Road 1, El Lago, TX 77586, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16260152821423440818&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nasa-foodmart",
      "poi_latitude": "29.5646564",
      "poi_longitude": "-95.0524551",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-c47e-77ef-b6e4-f6362dbfa367.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfc-c47e-77ef-b6e4-f6362dbfa367",
        "storage_key": "property/6737460151192625/019e1dfc-c47e-77ef-b6e4-f6362dbfa367.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJS-DcZHpiP4YRsoOCUteqp-E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_d1a01e64-1411-4add-aed9-90434e19e875",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "El Super",
      "poi_type": "Shopping & Retail",
      "poi_address": "803 E NASA Pkwy Ste 112, Webster, TX 77598, USA",
      "poi_short_description": "Supermarket chain selling produce, dairy, meat & other familiar grocery items.",
      "poi_long_description": "Supermarket chain selling produce, dairy, meat & other familiar grocery items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-8fbe-708b-8b59-0c113e2dc823.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-8fbe-708b-8b59-0c113e2dc823",
        "storage_key": "property/6737460151192625/019e1dfc-8fbe-708b-8b59-0c113e2dc823.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://elsupermarkets.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15321799485152354225&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-super",
      "poi_latitude": "29.5448331",
      "poi_longitude": "-95.1103738",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 346-715-5976",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-50ce-71f9-89c3-4bc5c16af525.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-50ce-71f9-89c3-4bc5c16af525",
        "storage_key": "property/6737460151192625/019e1dfa-50ce-71f9-89c3-4bc5c16af525.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIZF1XpScQIYRsd9EEHT3odQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_c2596f37-2c0b-42b5-954b-915e899585fd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "CLOSED",
      "poi_type": "Shopping & Retail",
      "poi_address": "570 El Dorado Blvd, Webster, TX 77598, USA",
      "poi_short_description": "Supermarket chain stocking meats & produce, plus a full selection of basic groceries.",
      "poi_long_description": "Supermarket chain stocking meats & produce, plus a full selection of basic groceries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-91f6-74af-bb13-3505a20e6ebd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-91f6-74af-bb13-3505a20e6ebd",
        "storage_key": "property/6737460151192625/019e1dfc-91f6-74af-bb13-3505a20e6ebd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.yourfoodtown.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14640698700252064901&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "closed",
      "poi_latitude": "29.5602465",
      "poi_longitude": "-95.1405001",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-786-3288",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-50ce-71f9-89c3-4bc5c16af525.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-50ce-71f9-89c3-4bc5c16af525",
        "storage_key": "property/6737460151192625/019e1dfa-50ce-71f9-89c3-4bc5c16af525.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeQpgFXicQIYRhSwM7OU1Lss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_9b87e032-1179-4af2-9f87-7bdc032a870f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "1301 E NASA Pkwy, Houston, TX 77058, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-8e54-776b-b96a-20c6b2a6a496.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-8e54-776b-b96a-20c6b2a6a496",
        "storage_key": "property/6737460151192625/019e1dfc-8e54-776b-b96a-20c6b2a6a496.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1301+nasa+pkwy-houston-tx-77058/id=11854",
      "poi_directions_map_url": "https://maps.google.com/?cid=537818363628491414&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "29.5479955",
      "poi_longitude": "-95.1019706",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-990-8024",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-5086-7098-aa85-b0ce772a582e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-5086-7098-aa85-b0ce772a582e",
        "storage_key": "property/6737460151192625/019e1dfa-5086-7098-aa85-b0ce772a582e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH8MVIv6cQIYRlhLCxfO2dgc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_6adc0147-692e-4a42-ac8c-b23ecdf32779",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Costco Wholesale",
      "poi_type": "Shopping & Retail",
      "poi_address": "1310 Jasmine Ave, Webster, TX 77598, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-903a-723f-8440-f58f4796bff3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-903a-723f-8440-f58f4796bff3",
        "storage_key": "property/6737460151192625/019e1dfc-903a-723f-8440-f58f4796bff3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/webster-TX-1330.html?utm_term=KW&utm_campaign=Homepage&utm_medium=GMB&utm_source=Google&utm_content=Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=3639438621570004531&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "29.5337935",
      "poi_longitude": "-95.1394705",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-707-7750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-509e-716a-9b77-f148af82e167.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-509e-716a-9b77-f148af82e167",
        "storage_key": "property/6737460151192625/019e1dfa-509e-716a-9b77-f148af82e167.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJHyMAvUidQIYRM3aEzCTigTI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "warehouse_store"
    },
    {
      "id": "custom_13d78716-0931-4d53-bfa8-61c3e51e3e21",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "1801 W Bay Area Blvd, Webster, TX 77598, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-9340-714f-a85a-b37b40140a0d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-9340-714f-a85a-b37b40140a0d",
        "storage_key": "property/6737460151192625/019e1dfc-9340-714f-a85a-b37b40140a0d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/baybrook/1837",
      "poi_directions_map_url": "https://maps.google.com/?cid=11130154673306662091&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "29.5360544",
      "poi_longitude": "-95.151189",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-819-4116",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-509e-716a-9b77-f148af82e167.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-509e-716a-9b77-f148af82e167",
        "storage_key": "property/6737460151192625/019e1dfa-509e-716a-9b77-f148af82e167.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJCxxUBGWbQIYRy_SYjbRAdpo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_ebd7b8d5-be6c-4510-9692-54f2697337bd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Best Buy",
      "poi_type": "Shopping & Retail",
      "poi_address": "19425 Gulf Fwy, Webster, TX 77598, USA",
      "poi_short_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_long_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-9387-71e8-8e7d-1508f4b67fda.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-9387-71e8-8e7d-1508f4b67fda",
        "storage_key": "property/6737460151192625/019e1dfc-9387-71e8-8e7d-1508f4b67fda.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.bestbuy.com/tx/webster/19425-gulf-fwy-242.html/?ref=NS&loc=ns100",
      "poi_directions_map_url": "https://maps.google.com/?cid=16679304524030941036&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "best-buy",
      "poi_latitude": "29.543781",
      "poi_longitude": "-95.139787",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-554-3004",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-509e-716a-9b77-f148af82e167.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-509e-716a-9b77-f148af82e167",
        "storage_key": "property/6737460151192625/019e1dfa-509e-716a-9b77-f148af82e167.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJG6EVJoKcQIYRbBduBxjLeOc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "electronics_store"
    },
    {
      "id": "custom_9fbc7e14-f914-4add-8244-7ad551b94bcf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Mc Whirter Elementary School",
      "poi_type": "Education",
      "poi_address": "300 Pennsylvania Ave, Webster, TX 77598, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-9891-769f-8abc-ae055300214b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-9891-769f-8abc-ae055300214b",
        "storage_key": "property/6737460151192625/019e1dfc-9891-769f-8abc-ae055300214b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://mcwhirter.ccisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10835443945066177171&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mc-whirter-elementary-school",
      "poi_latitude": "29.53429019999999",
      "poi_longitude": "-95.1211094",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 281-284-4800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-50bc-7131-934e-801ccaee7e0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-50bc-7131-934e-801ccaee7e0e",
        "storage_key": "property/6737460151192625/019e1dfa-50bc-7131-934e-801ccaee7e0e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCWRL9OucQIYRk6JTAdw6X5Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_00bd3804-8fb9-46d0-9483-7fa787176665",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Clear Creek Intermediate School",
      "poi_type": "Education",
      "poi_address": "2451 E Main St, League City, TX 77573, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-9849-70cd-9f50-d64acaa86c41.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-9849-70cd-9f50-d64acaa86c41",
        "storage_key": "property/6737460151192625/019e1dfc-9849-70cd-9f50-d64acaa86c41.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://clearcreekint.ccisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5088640651086038214&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clear-creek-intermediate-school",
      "poi_latitude": "29.5296286",
      "poi_longitude": "-95.0713368",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 281-284-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-50bc-7131-934e-801ccaee7e0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-50bc-7131-934e-801ccaee7e0e",
        "storage_key": "property/6737460151192625/019e1dfa-50bc-7131-934e-801ccaee7e0e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJUa_lokKdQIYRxoSYHbZ7nkY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_6808ae9c-338f-4416-b4fd-ac71eb435074",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Clear Creek High School",
      "poi_type": "Education",
      "poi_address": "2305 E Main St, League City, TX 77573, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-9776-7589-bed4-cdd04a34f514.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-9776-7589-bed4-cdd04a34f514",
        "storage_key": "property/6737460151192625/019e1dfc-9776-7589-bed4-cdd04a34f514.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://clearcreekhs.ccisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3944614550434849667&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clear-creek-high-school",
      "poi_latitude": "29.5244507",
      "poi_longitude": "-95.0726567",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 281-284-1700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-50bc-7131-934e-801ccaee7e0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-50bc-7131-934e-801ccaee7e0e",
        "storage_key": "property/6737460151192625/019e1dfa-50bc-7131-934e-801ccaee7e0e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJH3DoqEOdQIYRg6OBvggWvjY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_ae6d9949-a4a5-470d-a3db-28837d0c239a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Clear View High School",
      "poi_type": "Education",
      "poi_address": "500 S Walnut St, Webster, TX 77598, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-9588-7670-913c-6c5b66c1e332.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-9588-7670-913c-6c5b66c1e332",
        "storage_key": "property/6737460151192625/019e1dfc-9588-7670-913c-6c5b66c1e332.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://clearview.ccisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13458604954412165749&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clear-view-high-school",
      "poi_latitude": "29.5320727",
      "poi_longitude": "-95.1208356",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 281-284-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-50bc-7131-934e-801ccaee7e0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-50bc-7131-934e-801ccaee7e0e",
        "storage_key": "property/6737460151192625/019e1dfa-50bc-7131-934e-801ccaee7e0e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJeV6Y4uqcQIYRdaoMOOaRxro",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_31dc186c-37da-4fe9-8105-a06ecbb08e52",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Clear Path Alternative School",
      "poi_type": "Education",
      "poi_address": "1001 Magnolia Ave, Webster, TX 77598, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://clearpath.ccisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17230582044511257115&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clear-path-alternative-school",
      "poi_latitude": "29.5251794",
      "poi_longitude": "-95.121465",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 281-284-1600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-50bc-7131-934e-801ccaee7e0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-50bc-7131-934e-801ccaee7e0e",
        "storage_key": "property/6737460151192625/019e1dfa-50bc-7131-934e-801ccaee7e0e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcWEVicCcQIYRG0JR9BNTH-8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_29a3c639-b09a-401d-b0c2-3f8241859768",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Little People's Greater Life",
      "poi_type": "Education",
      "poi_address": "1655 FM 528 Rd, Webster, TX 77598, USA",
      "poi_short_description": "Relaxed, warm preschool facility, open to kids from 3 months to 12 years old, offering classes in sign language.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-94af-716f-b655-6be7ef60dfc4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-94af-716f-b655-6be7ef60dfc4",
        "storage_key": "property/6737460151192625/019e1dfc-94af-716f-b655-6be7ef60dfc4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://littlepeoplesgreaterlife.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2514353717970862946&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "little-peoples-greater-life",
      "poi_latitude": "29.5238317",
      "poi_longitude": "-95.1405655",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 281-332-8939",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-50bc-7131-934e-801ccaee7e0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-50bc-7131-934e-801ccaee7e0e",
        "storage_key": "property/6737460151192625/019e1dfa-50bc-7131-934e-801ccaee7e0e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5bP5QZacQIYRYgNWh2LH5CI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_7c73b00d-d4f9-4a28-8427-60d893d510be",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Kids 'R' Kids Learning Academy of Space Center",
      "poi_type": "Education",
      "poi_address": "151 W Texas Ave, Webster, TX 77598, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-98a4-72aa-920a-54e59120b57a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-98a4-72aa-920a-54e59120b57a",
        "storage_key": "property/6737460151192625/019e1dfc-98a4-72aa-920a-54e59120b57a.webp",
        "width": 600,
        "height": 402
      },
      "poi_business_url": "https://kidsrkids.com/space-center/?utm_source=gmb_listing&utm_medium=local&utm_campaign=localpack",
      "poi_directions_map_url": "https://maps.google.com/?cid=7534821981377572502&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kids-r-kids-learning-academy-of-space-center",
      "poi_latitude": "29.5497934",
      "poi_longitude": "-95.1319177",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 281-557-0062",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-50bc-7131-934e-801ccaee7e0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-50bc-7131-934e-801ccaee7e0e",
        "storage_key": "property/6737460151192625/019e1dfa-50bc-7131-934e-801ccaee7e0e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIUNkFIicQIYRlq7QvasQkWg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_ffef47a1-3596-4748-9fec-66a7889b9f97",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "The Growing Place",
      "poi_type": "Education",
      "poi_address": "228 N Texas Ave, Webster, TX 77598, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-9c9f-712a-b288-c9ce934cd794.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-9c9f-712a-b288-c9ce934cd794",
        "storage_key": "property/6737460151192625/019e1dfc-9c9f-712a-b288-c9ce934cd794.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://growingplacewebster.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3827102929946574464&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-growing-place",
      "poi_latitude": "29.5348602",
      "poi_longitude": "-95.1251023",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 281-545-3641",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-50bc-7131-934e-801ccaee7e0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-50bc-7131-934e-801ccaee7e0e",
        "storage_key": "property/6737460151192625/019e1dfa-50bc-7131-934e-801ccaee7e0e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkSKXhJOcQIYRgH5SgtaZHDU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_b28d0b59-67e8-4247-9810-e737d9ab2d96",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Distinct Abilities",
      "poi_type": "Education",
      "poi_address": "203 Blossom St, Webster, TX 77598, USA",
      "poi_short_description": "Day care center accommodating children with special needs such as autism.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-a200-727c-a8af-0431fbd313a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-a200-727c-a8af-0431fbd313a3",
        "storage_key": "property/6737460151192625/019e1dfc-a200-727c-a8af-0431fbd313a3.webp",
        "width": 400,
        "height": 300
      },
      "poi_business_url": "http://www.distinctabilities.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9604757092840104039&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "distinct-abilities",
      "poi_latitude": "29.5437",
      "poi_longitude": "-95.1251697",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-488-0436",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-50bc-7131-934e-801ccaee7e0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-50bc-7131-934e-801ccaee7e0e",
        "storage_key": "property/6737460151192625/019e1dfa-50bc-7131-934e-801ccaee7e0e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJWQOpoQGcQIYRZ-ClELDzSoU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_389c4a8c-c98d-411b-b8d3-38e2163bdbd9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "University of Houston-Clear Lake",
      "poi_type": "Education",
      "poi_address": "2700 Bay Area Blvd, Houston, TX 77058, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-20ed-728a-b4b2-b3d945341563.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfa-20ed-728a-b4b2-b3d945341563",
        "storage_key": "property/6737460151192625/019e1dfa-20ed-728a-b4b2-b3d945341563.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.uhcl.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17406779386354668934&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-houston-clear-lake",
      "poi_latitude": "29.5824608",
      "poi_longitude": "-95.0989342",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 281-283-7600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-50bc-7131-934e-801ccaee7e0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-50bc-7131-934e-801ccaee7e0e",
        "storage_key": "property/6737460151192625/019e1dfa-50bc-7131-934e-801ccaee7e0e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJBRIWAM2dQIYRhhVDd6BNkfE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_d110d3ff-cf53-44e1-9921-2cd3a28fa316",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Space Center Houston",
      "poi_type": "Entertainment",
      "poi_address": "1601 E NASA Pkwy, Houston, TX 77058, USA",
      "poi_short_description": "Educational center highlighting all eras of U.S. space travel via exhibits, tours & attractions.",
      "poi_long_description": "Educational center highlighting all eras of U.S. space travel via exhibits, tours & attractions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-2614-72cf-bf2c-fc3937a34e9f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfa-2614-72cf-bf2c-fc3937a34e9f",
        "storage_key": "property/6737460151192625/019e1dfa-2614-72cf-bf2c-fc3937a34e9f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.spacecenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1436836062198888726&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "space-center-houston",
      "poi_latitude": "29.551832",
      "poi_longitude": "-95.0981044",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 281-244-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-5087-77f1-9ef1-e7f9f1d66bc0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-5087-77f1-9ef1-e7f9f1d66bc0",
        "storage_key": "property/6737460151192625/019e1dfa-5087-77f1-9ef1-e7f9f1d66bc0.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJLZlhwACdQIYRFvnVL8mq8BM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_c4eca86c-0d2d-48fc-8664-24fb6dd7f6d8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Kemah Boardwalk",
      "poi_type": "Entertainment",
      "poi_address": "215 Kipp Ave, Kemah, TX 77565, USA",
      "poi_short_description": "Family-friendly entertainment including retro rides, a wooden roller coaster & two-story carousel.",
      "poi_long_description": "Family-friendly entertainment including retro rides, a wooden roller coaster & two-story carousel.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-a0ec-76fd-a165-50eb1237dc25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-a0ec-76fd-a165-50eb1237dc25",
        "storage_key": "property/6737460151192625/019e1dfc-a0ec-76fd-a165-50eb1237dc25.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.kemahboardwalk.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3506269467466928315&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kemah-boardwalk",
      "poi_latitude": "29.5473219",
      "poi_longitude": "-95.0202048",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 8 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 281-535-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-5086-7098-aa85-b0ce772a582e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-5086-7098-aa85-b0ce772a582e",
        "storage_key": "property/6737460151192625/019e1dfa-5086-7098-aa85-b0ce772a582e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-2iakAJjP4YRuxAq74DFqDA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "custom_359471f7-9e21-450c-8942-c1fe0404287b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Star Cinema Grill",
      "poi_type": "Entertainment",
      "poi_address": "702 Baybrook Mall, Friendswood, TX 77546, USA",
      "poi_short_description": "Cinema featuring dining options, heated reclining seats and waitstaff service, plus a bar for drinks.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-9e69-77b1-b971-e6bbb904edc4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-9e69-77b1-b971-e6bbb904edc4",
        "storage_key": "property/6737460151192625/019e1dfc-9e69-77b1-b971-e6bbb904edc4.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.starcinemagrill.net/movie-theater/baybrook",
      "poi_directions_map_url": "https://maps.google.com/?cid=12765688306792673863&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "star-cinema-grill",
      "poi_latitude": "29.545818",
      "poi_longitude": "-95.1504157",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-557-9300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-c47d-73ad-9e41-efe7e1ee1030.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfc-c47d-73ad-9e41-efe7e1ee1030",
        "storage_key": "property/6737460151192625/019e1dfc-c47d-73ad-9e41-efe7e1ee1030.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0fTv5JacQIYRRzK8J-HVKLE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_8159bd6f-0c2f-4fd8-890f-53452d0dedb5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Main Event Webster",
      "poi_type": "Entertainment",
      "poi_address": "1125 Magnolia Ave, Webster, TX 77598, USA",
      "poi_short_description": "Texas mini-chain with bowling, billiards, laser tag & arcade, plus eats & full bar.",
      "poi_long_description": "Texas mini-chain with bowling, billiards, laser tag & arcade, plus eats & full bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-1cb5-7766-b1c9-07a31c351e08.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfa-1cb5-7766-b1c9-07a31c351e08",
        "storage_key": "property/6737460151192625/019e1dfa-1cb5-7766-b1c9-07a31c351e08.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "http://www.mainevent.com/locations/texas/webster",
      "poi_directions_map_url": "https://maps.google.com/?cid=2824197253025658700&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "main-event-webster",
      "poi_latitude": "29.52384379999999",
      "poi_longitude": "-95.1228347",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 281-332-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-5089-748b-8c54-a184424bfd66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-5089-748b-8c54-a184424bfd66",
        "storage_key": "property/6737460151192625/019e1dfa-5089-748b-8c54-a184424bfd66.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRc4J1b6cQIYRTHc6OnCQMSc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_35699d4c-631f-46d9-aa37-75b8c54330e6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Topgolf Webster",
      "poi_type": "Entertainment",
      "poi_address": "21401 Gulf Fwy, Webster, TX 77598, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-1d1f-743c-b7aa-92fca5288ee2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfa-1d1f-743c-b7aa-92fca5288ee2",
        "storage_key": "property/6737460151192625/019e1dfa-1d1f-743c-b7aa-92fca5288ee2.webp",
        "width": 775,
        "height": 435
      },
      "poi_business_url": "https://topgolf.com/us/webster/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11038612063024895215&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "topgolf-webster",
      "poi_latitude": "29.5176204",
      "poi_longitude": "-95.1207231",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-657-1300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-5089-748b-8c54-a184424bfd66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-5089-748b-8c54-a184424bfd66",
        "storage_key": "property/6737460151192625/019e1dfa-5089-748b-8c54-a184424bfd66.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJVcmmxMecQIYR79TwrS8HMZk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_49931583-51af-4561-b808-4e6503874d68",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Dave & Buster's Friendswood",
      "poi_type": "Entertainment",
      "poi_address": "704 Baybrook Mall, Friendswood, TX 77546, USA",
      "poi_short_description": "Family-friendly chain offering a sports-bar-style setting for American food & arcade games.",
      "poi_long_description": "Family-friendly chain offering a sports-bar-style setting for American food & arcade games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-9fc9-719b-a705-1725e5ed5e44.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-9fc9-719b-a705-1725e5ed5e44",
        "storage_key": "property/6737460151192625/019e1dfc-9fc9-719b-a705-1725e5ed5e44.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.daveandbusters.com/us/en/about/locations/friendswood",
      "poi_directions_map_url": "https://maps.google.com/?cid=14621415837000172475&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dave--busters-friendswood",
      "poi_latitude": "29.545056",
      "poi_longitude": "-95.1502168",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-709-0600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-5089-748b-8c54-a184424bfd66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-5089-748b-8c54-a184424bfd66",
        "storage_key": "property/6737460151192625/019e1dfa-5089-748b-8c54-a184424bfd66.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJxSz-c3qbQIYRu4OqdTy06co",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_ac0f5235-91f0-4210-ba0e-d234d24d8a58",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Bay Area Museum",
      "poi_type": "Entertainment",
      "poi_address": "5000 NASA Road 1, Seabrook, TX 77586, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-a13a-7120-9055-d4482c473e4a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-a13a-7120-9055-d4482c473e4a",
        "storage_key": "property/6737460151192625/019e1dfc-a13a-7120-9055-d4482c473e4a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://museumbayarea.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6289041424846745937&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bay-area-museum",
      "poi_latitude": "29.5680042",
      "poi_longitude": "-95.069161",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 281-326-5950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-5087-77f1-9ef1-e7f9f1d66bc0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-5087-77f1-9ef1-e7f9f1d66bc0",
        "storage_key": "property/6737460151192625/019e1dfa-5087-77f1-9ef1-e7f9f1d66bc0.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJb04haIidQIYRUfG06dopR1c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_19a61d1b-fd1f-45a4-9217-2f1413902e78",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Butler Longhorn Museum",
      "poi_type": "Entertainment",
      "poi_address": "1220 Coryell St, League City, TX 77573, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17205980531784426299&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "butler-longhorn-museum",
      "poi_latitude": "29.51806269999999",
      "poi_longitude": "-95.0883791",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-5087-77f1-9ef1-e7f9f1d66bc0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-5087-77f1-9ef1-e7f9f1d66bc0",
        "storage_key": "property/6737460151192625/019e1dfa-5087-77f1-9ef1-e7f9f1d66bc0.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJjbfYBwCdQIYROyNM6SHsx-4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_f5b8cdc3-dc13-4943-b3ef-0cd266db27df",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Kindred Hospital Clear Lake",
      "poi_type": "Health and Wellness",
      "poi_address": "350 Blossom St, Webster, TX 77598, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-a0a2-7143-b0c4-9ad25d50ae23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-a0a2-7143-b0c4-9ad25d50ae23",
        "storage_key": "property/6737460151192625/019e1dfc-a0a2-7143-b0c4-9ad25d50ae23.webp",
        "width": 680,
        "height": 453
      },
      "poi_business_url": "https://www.kindredhospitals.com/locations/texas/clear-lake",
      "poi_directions_map_url": "https://maps.google.com/?cid=9796580276427523719&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kindred-hospital-clear-lake",
      "poi_latitude": "29.5436487",
      "poi_longitude": "-95.1275855",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-316-7800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-5089-748b-8c54-a5aecd4449ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-5089-748b-8c54-a5aecd4449ce",
        "storage_key": "property/6737460151192625/019e1dfa-5089-748b-8c54-a5aecd4449ce.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJFY_-nY6cQIYRh4YPXttx9Ic",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_c7319271-cf84-4517-a6fc-ce0defcdac67",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "UTMB Health Urgent Care, Webster",
      "poi_type": "Health and Wellness",
      "poi_address": "17448 State Hwy 3 2nd floor, Webster, TX 77598, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-a2bc-7795-9e6d-7e1b9e2c5408.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-a2bc-7795-9e6d-7e1b9e2c5408",
        "storage_key": "property/6737460151192625/019e1dfc-a2bc-7795-9e6d-7e1b9e2c5408.webp",
        "width": 1280,
        "height": 780
      },
      "poi_business_url": "https://www.utmbhealth.com/urgent-care",
      "poi_directions_map_url": "https://maps.google.com/?cid=1440311626852124633&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "utmb-health-urgent-care-webster",
      "poi_latitude": "29.5413969",
      "poi_longitude": "-95.1224877",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 832-505-1748",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-5086-7098-aa85-b0ce772a582e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-5086-7098-aa85-b0ce772a582e",
        "storage_key": "property/6737460151192625/019e1dfa-5086-7098-aa85-b0ce772a582e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhQKFmbSdQIYR2cdiJMsD_RM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_6cb96e75-7661-46e8-9ed4-92a851629e50",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Memorial Hermann-GoHealth Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "19419 Gulf Fwy ste.3, Webster, TX 77598, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-a28a-76e8-900b-bbe78d679b92.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-a28a-76e8-900b-bbe78d679b92",
        "storage_key": "property/6737460151192625/019e1dfc-a28a-76e8-900b-bbe78d679b92.webp",
        "width": 880,
        "height": 742
      },
      "poi_business_url": "https://www.gohealthuc.com/memorialhermann/locations/clear-lake?utm_source=gmb&utm_medium=organic&utm_content=memorialhermann-clear-lake",
      "poi_directions_map_url": "https://maps.google.com/?cid=4086185230324925044&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-hermann-gohealth-urgent-care",
      "poi_latitude": "29.5426101",
      "poi_longitude": "-95.1392669",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 346-788-3461",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-5086-7098-aa85-b0ce772a582e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-5086-7098-aa85-b0ce772a582e",
        "storage_key": "property/6737460151192625/019e1dfa-5086-7098-aa85-b0ce772a582e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJszYsmYOcQIYRdAL3Q9ELtTg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_db2c6a52-b5ec-42d4-a8dc-9df2c729ffb4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "NextCare Urgent Care, Nassua Bay",
      "poi_type": "Health and Wellness",
      "poi_address": "1202 E NASA Pkwy, Houston, TX 77058, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-a4b8-774f-a8fc-f678bda8b40f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-a4b8-774f-a8fc-f678bda8b40f",
        "storage_key": "property/6737460151192625/019e1dfc-a4b8-774f-a8fc-f678bda8b40f.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://nextcare.com/locations/tx/clear-lake/?utm_source=google&utm_medium=organic&utm_campaign=google_maps&utm_content=ClearLake",
      "poi_directions_map_url": "https://maps.google.com/?cid=18010284954251502252&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nextcare-urgent-care-nassua-bay",
      "poi_latitude": "29.5466502",
      "poi_longitude": "-95.1024584",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-335-0606",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-5086-7098-aa85-b0ce772a582e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-5086-7098-aa85-b0ce772a582e",
        "storage_key": "property/6737460151192625/019e1dfa-5086-7098-aa85-b0ce772a582e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJefh-C_6cQIYRrCK5Sb5i8fk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_e94608e3-d5cf-4ffa-8af6-91352a219478",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1801 W Bay Area Blvd, Webster, TX 77598, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-a5ee-710d-b8a3-41e072a7b580.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-a5ee-710d-b8a3-41e072a7b580",
        "storage_key": "property/6737460151192625/019e1dfc-a5ee-710d-b8a3-41e072a7b580.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cvs.com/store-locator/webster-tx-pharmacies/1801-w-bay-area-blvd-webster-tx-77598/storeid=16958?WT.mc_id=LS_GOOGLE_RX_16958",
      "poi_directions_map_url": "https://maps.google.com/?cid=10868780887166009343&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "29.5360544",
      "poi_longitude": "-95.151189",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-819-4117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-c491-7718-8f24-d05e43e14077.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfc-c491-7718-8f24-d05e43e14077",
        "storage_key": "property/6737460151192625/019e1dfc-c491-7718-8f24-d05e43e14077.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxaknB2WbQIYR_78VsaGq1ZY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_0ed88c4d-a024-46ba-a6aa-b4d15e3eb108",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "H-E-B Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "18611 Eastfield Dr, Webster, TX 77598, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-a59b-72a9-9991-861b2c90f88f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-a59b-72a9-9991-861b2c90f88f",
        "storage_key": "property/6737460151192625/019e1dfc-a59b-72a9-9991-861b2c90f88f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/pharmacy/common/landing?utm_source=google&utm_medium=organic&utm_campaign=gmb_pharmacy",
      "poi_directions_map_url": "https://maps.google.com/?cid=13838597757920388593&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b-pharmacy",
      "poi_latitude": "29.5521819",
      "poi_longitude": "-95.1493096",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 281-488-0179",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-c491-7718-8f24-d05e43e14077.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfc-c491-7718-8f24-d05e43e14077",
        "storage_key": "property/6737460151192625/019e1dfc-c491-7718-8f24-d05e43e14077.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy4b0XLqbQIYR8aVcPleTDMA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_32514523-e984-489c-8c03-234e701a3ca4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "The Yoga Institute Clear Lake",
      "poi_type": "Health and Wellness",
      "poi_address": "1354 E NASA Pkwy suite g, Houston, TX 77058, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-a7de-7355-ab88-495fed15cc1a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-a7de-7355-ab88-495fed15cc1a",
        "storage_key": "property/6737460151192625/019e1dfc-a7de-7355-ab88-495fed15cc1a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.yogainstitute.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8181347783583681993&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-yoga-institute-clear-lake",
      "poi_latitude": "29.5476393",
      "poi_longitude": "-95.099157",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-333-1646",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-50bc-7131-934e-801ccaee7e0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-50bc-7131-934e-801ccaee7e0e",
        "storage_key": "property/6737460151192625/019e1dfa-50bc-7131-934e-801ccaee7e0e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6weTXgidQIYRyU1vaHb8iXE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_0636c778-6dfa-483c-9b5d-8a7ab4a3d3fa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "136 Bay Area Blvd, Webster, TX 77598, USA",
      "poi_short_description": "Gym featuring hourlong workouts mixing cardio exercises with strength training.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-ac38-75c2-abfe-f639b0521006.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-ac38-75c2-abfe-f639b0521006",
        "storage_key": "property/6737460151192625/019e1dfc-ac38-75c2-abfe-f639b0521006.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/webster-texas-0754?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=8790660473924558466&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "29.5488083",
      "poi_longitude": "-95.1304478",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 832-598-7199",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-5086-7098-aa85-b0ce772a582e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-5086-7098-aa85-b0ce772a582e",
        "storage_key": "property/6737460151192625/019e1dfa-5086-7098-aa85-b0ce772a582e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcdZ-T4icQIYRgh5XSSCz_nk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_88ce72bc-24b8-4de7-85cc-a9a25803318f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "560 El Dorado Blvd, Webster, TX 77598, USA",
      "poi_short_description": "Relaxed chain offering numerous machines and various classes, along with massage chairs, tanning beds and hydromassage.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-3229-771f-be11-27c362f5e9bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfa-3229-771f-be11-27c362f5e9bd",
        "storage_key": "property/6737460151192625/019e1dfa-3229-771f-be11-27c362f5e9bd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/webster-el-dorado-tx?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=4169089902244546256&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "29.55978",
      "poi_longitude": "-95.14106",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 832-500-5510",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-5086-7098-aa85-b0ce772a582e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-5086-7098-aa85-b0ce772a582e",
        "storage_key": "property/6737460151192625/019e1dfa-5086-7098-aa85-b0ce772a582e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYduIUXicQIYR0Eb0Yy2V2zk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_fff692a3-9d1b-4458-a8a6-f6bf879f1ead",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Challenger Seven Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2301 W Nasa Blvd, Webster, TX 77598, USA",
      "poi_short_description": "Challenger Space Shuttle disaster memorial & learning center in a 300-acre park with wetlands.",
      "poi_long_description": "Challenger Space Shuttle disaster memorial & learning center in a 300-acre park with wetlands.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-3e57-76c7-b4a6-452e44424b7f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfa-3e57-76c7-b4a6-452e44424b7f",
        "storage_key": "property/6737460151192625/019e1dfa-3e57-76c7-b4a6-452e44424b7f.webp",
        "width": 1280,
        "height": 921
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13827686735360768045&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "challenger-seven-memorial-park",
      "poi_latitude": "29.5099629",
      "poi_longitude": "-95.1360548",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-332-1903",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-50bb-700c-af69-941795502e6f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-50bb-700c-af69-941795502e6f",
        "storage_key": "property/6737460151192625/019e1dfa-50bb-700c-af69-941795502e6f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-95kEAGdQIYRLTiP1tLP5b8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e216d77a-0b3c-490d-ae21-c85c3911548f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Texas Avenue Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "17100 N Texas Ave, Webster, TX 77598, USA",
      "poi_short_description": "Urban park with baseball, softball & basketball fields, tennis courts, playgrounds & walking track.",
      "poi_long_description": "Urban park with baseball, softball & basketball fields, tennis courts, playgrounds & walking track.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-a89c-76d0-9c72-d69c8394f913.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-a89c-76d0-9c72-d69c8394f913",
        "storage_key": "property/6737460151192625/019e1dfc-a89c-76d0-9c72-d69c8394f913.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cityofwebster.com/886/Texas-Avenue-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=6453574986490467572&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-avenue-park",
      "poi_latitude": "29.5405465",
      "poi_longitude": "-95.1331001",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 281-332-1826",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-50bb-700c-af69-941795502e6f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-50bb-700c-af69-941795502e6f",
        "storage_key": "property/6737460151192625/019e1dfa-50bb-700c-af69-941795502e6f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJKx-fZoWcQIYR9FQc-UG0j1k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_596f375e-a20b-4a5c-87d7-7f82210cd0a3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Great Wolf Lodge | Webster",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1000 Great Wolf Wy, Webster, TX 77598, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-afa8-76bb-a612-49e3a300e51b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-afa8-76bb-a612-49e3a300e51b",
        "storage_key": "property/6737460151192625/019e1dfc-afa8-76bb-a612-49e3a300e51b.webp",
        "width": 1280,
        "height": 881
      },
      "poi_business_url": "https://www.greatwolf.com/webster?utm_source=google&utm_medium=organic&utm_campaign=gmb-webster",
      "poi_directions_map_url": "https://maps.google.com/?cid=16707537034578491455&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "great-wolf-lodge--webster",
      "poi_latitude": "29.5181005",
      "poi_longitude": "-95.1155855",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 888-981-9653",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-c47f-74d6-9144-c82aaf5e6153.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfc-c47f-74d6-9144-c82aaf5e6153",
        "storage_key": "property/6737460151192625/019e1dfc-c47f-74d6-9144-c82aaf5e6153.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJUZExrdydQIYRP_i7oWkY3ec",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "resort_hotel"
    },
    {
      "id": "custom_0dd70732-be70-4eb7-9109-e422c8232962",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Walnut Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Walnut Park, 400 N Walnut, Webster, TX 77598, USA",
      "poi_short_description": "Compact green space with well-kept, tree-lined walking paths & a children's playground.",
      "poi_long_description": "Compact green space with well-kept, tree-lined walking paths & a children's playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-a914-7292-ab77-88a4e1e2718b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-a914-7292-ab77-88a4e1e2718b",
        "storage_key": "property/6737460151192625/019e1dfc-a914-7292-ab77-88a4e1e2718b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofwebster.com/887/Walnut-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=8105699125215052008&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walnut-park",
      "poi_latitude": "29.5368433",
      "poi_longitude": "-95.1249188",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 281-332-1826",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-50bb-700c-af69-941795502e6f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-50bb-700c-af69-941795502e6f",
        "storage_key": "property/6737460151192625/019e1dfa-50bb-700c-af69-941795502e6f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJrVuS_JKcQIYR6ECjlmg6fXA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_79873774-ab12-448d-86fc-c95b05608623",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Green Acres Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "901 Whitehall Ln, Houston, TX 77058, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-ac16-715c-b065-27bc5492a753.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-ac16-715c-b065-27bc5492a753",
        "storage_key": "property/6737460151192625/019e1dfc-ac16-715c-b065-27bc5492a753.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13919799271883647312&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "green-acres-park",
      "poi_latitude": "29.5410095",
      "poi_longitude": "-95.1037134",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-332-1826",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-50bb-700c-af69-941795502e6f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-50bb-700c-af69-941795502e6f",
        "storage_key": "property/6737460151192625/019e1dfa-50bb-700c-af69-941795502e6f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8bOXLv2cQIYRUKldAbAPLcE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_3c4137e6-b598-46cd-b210-a5a3a0966c4f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Clear Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5001 E NASA Pkwy, Seabrook, TX 77586, USA",
      "poi_short_description": "Park with archaeological features on 59 acres with fishing pier, boat launch, playground & trails.",
      "poi_long_description": "Park with archaeological features on 59 acres with fishing pier, boat launch, playground & trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-3ec2-76c6-aeb0-988c7b276e3c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfa-3ec2-76c6-aeb0-988c7b276e3c",
        "storage_key": "property/6737460151192625/019e1dfa-3ec2-76c6-aeb0-988c7b276e3c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hcp2.com/facilities/list-parks/104-clear-lake-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=11356940434028911940&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clear-lake-park",
      "poi_latitude": "29.5655933",
      "poi_longitude": "-95.0678815",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 281-326-6539",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-50bb-700c-af69-941795502e6f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-50bb-700c-af69-941795502e6f",
        "storage_key": "property/6737460151192625/019e1dfa-50bb-700c-af69-941795502e6f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJIVBSp4-dQIYRRF2QMSf1m50",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1870dab3-c860-4aeb-9e7f-d8b84a41666f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Bay Area Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7500 Bay Area Blvd, Houston, TX 77058, USA",
      "poi_short_description": "Recreation site on the bayou with a duck pond, baseball field, dog park & playground.",
      "poi_long_description": "Recreation site on the bayou with a duck pond, baseball field, dog park & playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-4287-732c-ac55-562ef1cbea18.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfa-4287-732c-ac55-562ef1cbea18",
        "storage_key": "property/6737460151192625/019e1dfa-4287-732c-ac55-562ef1cbea18.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hcp2.com/NEIGHBORHOOD-SERVICES/Parks-and-Trails",
      "poi_directions_map_url": "https://maps.google.com/?cid=9303752298704927509&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bay-area-park",
      "poi_latitude": "29.5966259",
      "poi_longitude": "-95.0893592",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 713-274-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-50bb-700c-af69-941795502e6f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-50bb-700c-af69-941795502e6f",
        "storage_key": "property/6737460151192625/019e1dfa-50bb-700c-af69-941795502e6f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJezAdT9idQIYRFfuHGmyRHYE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_880e6de1-d684-47b1-a11a-383a9d653723",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "David Braun Park at Lake Nassau",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "18900 Upper Bay Rd, Houston, TX 77058, USA",
      "poi_short_description": "Lakeside park with a playground, picnic areas, baseball and tennis courts, and walking trail.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-ac83-740f-92d3-95ac99bb94ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-ac83-740f-92d3-95ac99bb94ab",
        "storage_key": "property/6737460151192625/019e1dfc-ac83-740f-92d3-95ac99bb94ab.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.nassaubay.com/200/David-Braun-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=3904215505917581461&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "david-braun-park-at-lake-nassau",
      "poi_latitude": "29.5331016",
      "poi_longitude": "-95.0883056",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 281-333-4211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-50bb-700c-af69-941795502e6f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-50bb-700c-af69-941795502e6f",
        "storage_key": "property/6737460151192625/019e1dfa-50bb-700c-af69-941795502e6f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJw7de3hadQIYRlRjKNFGPLjY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_48246f53-924a-42c8-b2d3-0853c8951c93",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Nassau Bay Peninsula Wildlife Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Houston, TX 77058, USA",
      "poi_short_description": "This 76-acre wetland area features a nature trail with information signs & benches.",
      "poi_long_description": "This 76-acre wetland area features a nature trail with information signs & benches.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-ac9b-768b-8c8e-125bc7449ba4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-ac9b-768b-8c8e-125bc7449ba4",
        "storage_key": "property/6737460151192625/019e1dfc-ac9b-768b-8c8e-125bc7449ba4.webp",
        "width": 1024,
        "height": 768
      },
      "poi_business_url": "https://www.nassaubay.com/201/Nassau-Peninsula",
      "poi_directions_map_url": "https://maps.google.com/?cid=16303487144669998135&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nassau-bay-peninsula-wildlife-park",
      "poi_latitude": "29.5420868",
      "poi_longitude": "-95.081869",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 281-333-2944",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-50bb-700c-af69-941795502e6f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-50bb-700c-af69-941795502e6f",
        "storage_key": "property/6737460151192625/019e1dfa-50bb-700c-af69-941795502e6f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJgVtj2xKdQIYRN-wzsi2fQeI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_6c54f42f-1102-4248-bbf8-a4dd2f4214cd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Armand Bayou Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8500 Bay Area Blvd, Pasadena, TX 77507, USA",
      "poi_short_description": "Vast nature preserve with walking trails & many educational activities, such as guided canoe trips.",
      "poi_long_description": "Vast nature preserve with walking trails & many educational activities, such as guided canoe trips.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-3fe2-7489-95ad-8964184baf24.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfa-3fe2-7489-95ad-8964184baf24",
        "storage_key": "property/6737460151192625/019e1dfa-3fe2-7489-95ad-8964184baf24.webp",
        "width": 1024,
        "height": 682
      },
      "poi_business_url": "http://www.abnc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9274310725211214610&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "armand-bayou-nature-center",
      "poi_latitude": "29.5962814",
      "poi_longitude": "-95.0721502",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 281-474-2551",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-50bb-700c-af69-941795502e6f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-50bb-700c-af69-941795502e6f",
        "storage_key": "property/6737460151192625/019e1dfa-50bb-700c-af69-941795502e6f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7TKtGuKdQIYRElPPmHf4tIA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_ca0a0d93-3b05-4876-8550-cf738c16e5d1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Bay Area Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "801 Bay Area Blvd, Houston, TX 77062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-b2ba-708d-b29f-e5eb7dfcc46e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-b2ba-708d-b29f-e5eb7dfcc46e",
        "storage_key": "property/6737460151192625/019e1dfc-b2ba-708d-b29f-e5eb7dfcc46e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17875593883594312405&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bay-area-park--ride",
      "poi_latitude": "29.552879",
      "poi_longitude": "-95.124182",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-c49d-707a-91f8-cb380fd48c09.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfc-c49d-707a-91f8-cb380fd48c09",
        "storage_key": "property/6737460151192625/019e1dfc-c49d-707a-91f8-cb380fd48c09.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJGf2WA96dQIYR1crInO3dEvg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_f7b63029-135d-4a9d-a77a-7ae2e03167d6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "El Dorado Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "203 W El Dorado Blvd, Friendswood, TX 77546, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-b8b6-7257-9fa0-4a53ff7cda39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-b8b6-7257-9fa0-4a53ff7cda39",
        "storage_key": "property/6737460151192625/019e1dfc-b8b6-7257-9fa0-4a53ff7cda39.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17653152942922900114&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-dorado-park--ride",
      "poi_latitude": "29.5491606",
      "poi_longitude": "-95.1583549",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-c49d-707a-91f8-cb380fd48c09.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfc-c49d-707a-91f8-cb380fd48c09",
        "storage_key": "property/6737460151192625/019e1dfc-c49d-707a-91f8-cb380fd48c09.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJXZUQ43WbQIYRkqKPOBKZ_PQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_b680ee84-b42a-4c5e-b980-fb792fc6aebd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Fuqua Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "11755 Sabo Rd, Houston, TX 77089, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-bd72-74df-b1ef-1169d8f6554d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-bd72-74df-b1ef-1169d8f6554d",
        "storage_key": "property/6737460151192625/019e1dfc-bd72-74df-b1ef-1169d8f6554d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6784345919959218921&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fuqua-park--ride",
      "poi_latitude": "29.6098305",
      "poi_longitude": "-95.2169622",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-c49d-707a-91f8-cb380fd48c09.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfc-c49d-707a-91f8-cb380fd48c09",
        "storage_key": "property/6737460151192625/019e1dfc-c49d-707a-91f8-cb380fd48c09.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJC_ramuWZQIYR6TqKUKvWJl4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_7a519c55-fa3f-4bec-bd6b-b695528199df",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Monroe Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "8833 1/2 Gulf Fwy, Houston, TX 77017, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-b5e1-7778-9f53-a062778e6a5d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-b5e1-7778-9f53-a062778e6a5d",
        "storage_key": "property/6737460151192625/019e1dfc-b5e1-7778-9f53-a062778e6a5d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14541391259546629484&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "monroe-park-and-ride",
      "poi_latitude": "29.6639737",
      "poi_longitude": "-95.2545992",
      "poi_miles_from_property": "12.6",
      "poi_walking_minutes": "4 hours 39 mins",
      "poi_biking_minutes": "1 hour 22 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-c49d-707a-91f8-cb380fd48c09.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfc-c49d-707a-91f8-cb380fd48c09",
        "storage_key": "property/6737460151192625/019e1dfc-c49d-707a-91f8-cb380fd48c09.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJq5iUHMeXQIYRbDU_lU5mzck",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_0853183c-0e63-499e-b3b0-09b5414098cd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Baybrook Mall",
      "poi_type": "Transportation & Transit",
      "poi_address": "500 Baybrook Mall, Friendswood, TX 77546, USA",
      "poi_short_description": "Casual shopping plaza with stores for apparel, footwear, jewelry, home goods & kids, plus dining.",
      "poi_long_description": "Casual shopping plaza with stores for apparel, footwear, jewelry, home goods & kids, plus dining.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-1c62-7578-8525-3b68cdddce30.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfa-1c62-7578-8525-3b68cdddce30",
        "storage_key": "property/6737460151192625/019e1dfa-1c62-7578-8525-3b68cdddce30.webp",
        "width": 600,
        "height": 400
      },
      "poi_business_url": "https://www.baybrookmall.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=3962758813461213470&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baybrook-mall",
      "poi_latitude": "29.5427508",
      "poi_longitude": "-95.148508",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-667-9100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-509e-716a-9b77-f148af82e167.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-509e-716a-9b77-f148af82e167",
        "storage_key": "property/6737460151192625/019e1dfa-509e-716a-9b77-f148af82e167.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJOf21c3qbQIYRHnHnLiWM_jY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_48bc6ad6-ed7c-45d2-9098-446b937bbae6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "NASA Johnson Space Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Clear Lake, 2101 E NASA Pkwy, Houston, TX 77058, USA",
      "poi_short_description": "NASA's 1,700-acre facility used for mission control & training shuttle & space station astronauts.",
      "poi_long_description": "NASA's 1,700-acre facility used for mission control & training shuttle & space station astronauts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-b4c1-71be-a6cb-0c8f97da45b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-b4c1-71be-a6cb-0c8f97da45b8",
        "storage_key": "property/6737460151192625/019e1dfc-b4c1-71be-a6cb-0c8f97da45b8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.nasa.gov/centers/johnson/home/index.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=2389238764222131620&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nasa-johnson-space-center",
      "poi_latitude": "29.552908",
      "poi_longitude": "-95.0933748",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-483-0123",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-50bc-7131-934e-801ccaee7e0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-50bc-7131-934e-801ccaee7e0e",
        "storage_key": "property/6737460151192625/019e1dfa-50bc-7131-934e-801ccaee7e0e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJc29kHLCdQIYRpK0NUf9HKCE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "research_institute"
    },
    {
      "id": "custom_6b625860-f21d-46f8-b33b-3b41cbd518ce",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "HCA Houston Healthcare Clear Lake",
      "poi_type": "Major Employers & Offices",
      "poi_address": "500 W Medical Ctr Blvd, Webster, TX 77598, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-3940-75d8-b46b-fe21de2de334.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfa-3940-75d8-b46b-fe21de2de334",
        "storage_key": "property/6737460151192625/019e1dfa-3940-75d8-b46b-fe21de2de334.webp",
        "width": 1080,
        "height": 607
      },
      "poi_business_url": "https://www.hcahoustonhealthcare.com/locations/clear-lake?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=1498573804104781872&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hca-houston-healthcare-clear-lake",
      "poi_latitude": "29.5408696",
      "poi_longitude": "-95.1271676",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-332-2511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-5089-748b-8c54-a5aecd4449ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-5089-748b-8c54-a5aecd4449ce",
        "storage_key": "property/6737460151192625/019e1dfa-5089-748b-8c54-a5aecd4449ce.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJAw22Co6cQIYRMBBfX-8AzBQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_905b0d73-ed64-461b-8467-a75c6cb1e181",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "UTMB Health Clear Lake Campus Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "200 Blossom St, Webster, TX 77598, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-b5df-7017-a2db-72e94d795bb7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-b5df-7017-a2db-72e94d795bb7",
        "storage_key": "property/6737460151192625/019e1dfc-b5df-7017-a2db-72e94d795bb7.webp",
        "width": 1000,
        "height": 565
      },
      "poi_business_url": "https://www.utmbhealth.com/clc",
      "poi_directions_map_url": "https://maps.google.com/?cid=3313281454647947128&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "utmb-health-clear-lake-campus-hospital",
      "poi_latitude": "29.5447851",
      "poi_longitude": "-95.1259629",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 832-632-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-5089-748b-8c54-a5aecd4449ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-5089-748b-8c54-a5aecd4449ce",
        "storage_key": "property/6737460151192625/019e1dfa-5089-748b-8c54-a5aecd4449ce.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJh0-iflqdQIYReC8use0j-y0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_aa4ba324-76c5-43ec-8e21-91d68e0986c3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Houston Methodist Clear Lake Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "18300 Houston Methodist Dr, Houston, TX 77058, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-b9d9-77cd-a99a-69404206e126.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-b9d9-77cd-a99a-69404206e126",
        "storage_key": "property/6737460151192625/019e1dfc-b9d9-77cd-a99a-69404206e126.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.houstonmethodist.org/locations/clear-lake/?utm_source=gmb&utm_medium=organic&utm_campaign=all_location_gmb&utm_content=website-click",
      "poi_directions_map_url": "https://maps.google.com/?cid=14593435753938146129&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "houston-methodist-clear-lake-hospital",
      "poi_latitude": "29.549487",
      "poi_longitude": "-95.0862312",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 281-523-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-5089-748b-8c54-a5aecd4449ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-5089-748b-8c54-a5aecd4449ce",
        "storage_key": "property/6737460151192625/019e1dfa-5089-748b-8c54-a5aecd4449ce.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0YjgngmdQIYRUdP3tX9Mhso",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_376103bf-76c5-4638-8092-2bb4afc915b5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Vibra Hospital of Clear Lake",
      "poi_type": "Major Employers & Offices",
      "poi_address": "709 W Medical Ctr Blvd, Webster, TX 77598, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-b960-741e-89de-75deb1dde353.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-b960-741e-89de-75deb1dde353",
        "storage_key": "property/6737460151192625/019e1dfc-b960-741e-89de-75deb1dde353.webp",
        "width": 1280,
        "height": 846
      },
      "poi_business_url": "http://vhclearlake.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6517881310022973039&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vibra-hospital-of-clear-lake",
      "poi_latitude": "29.5375459",
      "poi_longitude": "-95.1297512",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 281-332-3322",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-5089-748b-8c54-a5aecd4449ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-5089-748b-8c54-a5aecd4449ce",
        "storage_key": "property/6737460151192625/019e1dfa-5089-748b-8c54-a5aecd4449ce.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJv6O9r5GcQIYRb7YTrIQqdFo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_8c2ab6c4-cb18-4eb2-9e2a-962cf0560b11",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Lockheed Martin Space Company",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2100 Space Park Dr, Houston, TX 77058, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9041415638596427946&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lockheed-martin-space-company",
      "poi_latitude": "29.5480022",
      "poi_longitude": "-95.085083",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-5086-7098-aa85-b0ce772a582e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-5086-7098-aa85-b0ce772a582e",
        "storage_key": "property/6737460151192625/019e1dfa-5086-7098-aa85-b0ce772a582e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKWGJ8QudQIYRqqAzrZ6PeX0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_86d15f33-7190-45d9-84d2-30ccda90fa1e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Axiom Space - Headquarters & Spacesuit Facility",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1300 Hercules Ave, Houston, TX 77058, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-b97b-74ad-b9d0-72a03f972ade.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-b97b-74ad-b9d0-72a03f972ade",
        "storage_key": "property/6737460151192625/019e1dfc-b97b-74ad-b9d0-72a03f972ade.webp",
        "width": 1280,
        "height": 918
      },
      "poi_business_url": "https://www.axiomspace.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10716935983294945610&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "axiom-space---headquarters--spacesuit-facility",
      "poi_latitude": "29.5566231",
      "poi_longitude": "-95.1107909",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 346-293-7045",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-5086-7098-aa85-b0ce772a582e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-5086-7098-aa85-b0ce772a582e",
        "storage_key": "property/6737460151192625/019e1dfa-5086-7098-aa85-b0ce772a582e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtW7-4E2dQIYRSpnl_H40upQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_c47f196f-50d2-46f7-89e8-2408dcb57c3d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "poi_name": "Intuitive Machines",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3700 Bay Area Blvd #600, Houston, TX 77058, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfc-be1f-726e-8a36-0ccb9485e120.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfc-be1f-726e-8a36-0ccb9485e120",
        "storage_key": "property/6737460151192625/019e1dfc-be1f-726e-8a36-0ccb9485e120.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.intuitivemachines.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16068624811863511446&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "intuitive-machines",
      "poi_latitude": "29.5903532",
      "poi_longitude": "-95.1006171",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 281-520-3703",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-5086-7098-aa85-b0ce772a582e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfa-5086-7098-aa85-b0ce772a582e",
        "storage_key": "property/6737460151192625/019e1dfa-5086-7098-aa85-b0ce772a582e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvXDgR9OdQIYRlhEnlCE5_94",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    }
  ],
  "office_hours": [
    {
      "id": "ec_6605df4a9bfb6aa834c7ecbc",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_e1c43ba3abfa86ecd1f40c82",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_a8837a5cb30a5c393aa3a7e2",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_d9663d0bc317d354d4e2f155",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_422a4143aa8a31b262fbddf2",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_b9c82b03fea261b20ff9f427",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_1b3f8ba644713c5a963fa957",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "rating": "5",
      "name": "Jacqueline Cruz",
      "text": "The property is absolutely beautiful and well-maintained. The staff is amazing, always friendly, professional, and willing to help with anything I need. I’ve had a great experience here and highly recommend it!",
      "date": "2025-09-25",
      "title": "false"
    },
    {
      "id": "ec_bfe39202740a288dcfd402f7",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "rating": "5",
      "name": "Xavier Rodriguez",
      "text": "Andrea was quite the delight to work with throughout the whole leasing process. From start to finish she was professional, knowledgeable, and overall extremely helpful. Andrea truly swayed my decision and led me to file my application and start the move in process immediately! Looking forward to calling Baystone Apartments my new home!",
      "date": "2025-10-15",
      "title": "false"
    },
    {
      "id": "ec_6c01d961776f2124ead8ab96",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "rating": "5",
      "name": "Monica Robinson",
      "text": "I’ve had a great experience at Baystone Apartments. The management team is professional, responsive, and genuinely cares about residents. Maintenance requests are handled quickly and efficiently, and the property is always clean and well-kept. The community is quiet, safe, and welcoming, which makes it feel like home. I highly recommend Baystone Apartments to anyone looking for quality living and excellent service.",
      "date": "2026-01-19",
      "title": "false"
    },
    {
      "id": "ec_4492f52c3730211cbf09d693",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "rating": "5",
      "name": "Marilou",
      "text": "I have been a resident for over a year and I have to say I truly appreciate the office manager, staff and maintenance for doing a wonderful job and always helping out anyway they can. I recently had an issue with my neighbor and the office was quick to resolve the issue and continue to help in any way that they could. They are always making sure to make the property clean and looking it's best. Because this is where I call home I really appreciate their hard work and helping me feel safe and loving the place our little community.",
      "date": "2025-12-04",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_12453ad5-de04-4aee-8943-b003f5116277",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019e1dfa-04da-71cf-9cea-85c5c30c165d.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1dfa-04da-71cf-9cea-85c5c30c165d",
        "storage_key": "property/6737460151192625/019e1dfa-04da-71cf-9cea-85c5c30c165d.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Baystone",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=68ae6cb0986136e94b34c61c"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01993e1c-58e4-71eb-81fb-c7e1cfcb5d7a",
      "lead_source": "LANDING_PAGE",
      "name": "rreaf-baystone-lp",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625"
    },
    {
      "lead_collector_id": "019a271d-0ebd-725e-bc13-173905fc978e",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "rreaf-baystone-new",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "generator",
      "page_item_url": "apartments-in-unit-laundry-webster-tx",
      "search_query": "apartments with in-unit laundry Webster TX",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Webster, TX",
      "h2_subtitle": "Find the convenience of in-unit laundry amenities at Baystone Apartments. Explore our floor plans in Webster, TX featuring this essential perk.",
      "page_copy": "Welcome to Baystone Apartments, where the convenience of in-unit laundry transforms your apartment living in Webster, TX. Our selection of one, two, and three-bedroom apartments ensures you find the perfect home that suits your lifestyle. Each unit comes equipped with modern conveniences, making daily life easier and more enjoyable. \n\nAt Baystone Apartments, not only do you have in-unit laundry, but you also enjoy a host of amenities including a fitness center, package service, cabana, and free Wi-Fi. Our vibrant community is managed on-site, ensuring swift assistance whenever you need it. Located in the heart of Webster, residents can easily access local attractions and services. Visit today and see why Baystone Apartments is the ideal choice for comfortable living with all the must-have features.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019d0783-f4bc-713b-9e3e-08df5e2478a4.webp",
      "featured_image_media": {
        "alt_text": "A beautiful outdoor swimming pool with a red bridge and lush landscaping.",
        "public_id": "019d0783-f4bc-713b-9e3e-08df5e2478a4",
        "storage_key": "property/6737460151192625/019d0783-f4bc-713b-9e3e-08df5e2478a4.webp",
        "width": 1239,
        "height": 837
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry - Webster, TX",
      "seo_description": "Discover Baystone Apartments with in-unit laundry in Webster, TX. Enjoy modern amenities in your new home. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "generator",
      "page_item_url": "baystone-apartments-air-conditioning-harris-county",
      "search_query": "Baystone Apartments with air conditioning Harris County",
      "category": "Amenity",
      "h1_title": "Baystone Apartments with Air Conditioning",
      "h2_subtitle": "Enjoy the comfort of air conditioning at Baystone Apartments. Discover modern living in Harris County with our spacious floor plans.",
      "page_copy": "Experience optimal comfort at Baystone Apartments, thoughtfully designed with air conditioning to keep you cool in the vibrant climate of Harris County. Located in Webster, TX, our community offers spacious one, two, and three-bedroom floor plans, ensuring you find the perfect fit. Each apartment is meticulously maintained, providing a refreshing retreat from the Texas heat with central air conditioning included.\n\nBeyond in-unit climate control, Baystone Apartments offers a suite of exceptional amenities such as package service, a fitness center, Wi-Fi, and a stylish cabana for leisure. Enjoy the added convenience of on-site management dedicated to providing a premier living experience. Discover a lifestyle of ease and comfort in Harris County. Schedule a tour today and explore why Baystone is the place you'll love to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019d0783-f4bc-713b-9e3e-08df5e2478a4.webp",
      "featured_image_media": {
        "alt_text": "A beautiful outdoor swimming pool with a red bridge and lush landscaping.",
        "public_id": "019d0783-f4bc-713b-9e3e-08df5e2478a4",
        "storage_key": "property/6737460151192625/019d0783-f4bc-713b-9e3e-08df5e2478a4.webp",
        "width": 1239,
        "height": 837
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Baystone Apartments with AC in Harris County",
      "seo_description": "Stay cool at Baystone Apartments with air conditioning in Harris County. Explore our amenities and spacious layouts—schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "generator",
      "page_item_url": "webster-apartments-with-pool-access",
      "search_query": "Webster apartments with pool access",
      "category": "Amenity",
      "h1_title": "Webster Apartments with Pool Access",
      "h2_subtitle": "Dive into comfort at Baystone Apartments in Webster. Enjoy pool access and other top-notch amenities that complement our spacious floor plans.",
      "page_copy": "Discover resort-style living at Baystone Apartments in Webster, TX, where having pool access transforms your everyday lifestyle. Our inviting community offers spacious one, two, and three-bedroom options, providing a home fit for any lifestyle. With our refreshing pool and a stylish cabana, relaxation is just steps away from your front door.\n\nBeyond our exceptional pool area, residents at Baystone enjoy a variety of amenities including package receiving, a modern fitness center, and the convenience of on-site management. Our vibrant community is nestled in the heart of Webster, providing easy access to local attractions and essential services. Dive into a lifestyle of comfort and leisure at Baystone Apartments—schedule your visit today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019d0783-f4bc-713b-9e3e-08df5e2478a4.webp",
      "featured_image_media": {
        "alt_text": "A beautiful outdoor swimming pool with a red bridge and lush landscaping.",
        "public_id": "019d0783-f4bc-713b-9e3e-08df5e2478a4",
        "storage_key": "property/6737460151192625/019d0783-f4bc-713b-9e3e-08df5e2478a4.webp",
        "width": 1239,
        "height": 837
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Webster Apartments with Pool Access",
      "seo_description": "Enjoy poolside relaxation at Baystone Apartments in Webster. Dive into a vibrant community with top-tier amenities. Book a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "generator",
      "page_item_url": "apartments-dishwasher-near-nasa-parkway",
      "search_query": "apartments with dishwasher near Nasa Parkway",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwasher Near Nasa Parkway",
      "h2_subtitle": "Discover the ease of kitchens equipped with dishwashers at Baystone Apartments. Located conveniently near Nasa Parkway in Webster, TX.",
      "page_copy": "Find convenience and modern living at Baystone Apartments, located near Nasa Parkway in Webster, TX, where each apartment comes equipped with a dishwasher. Our spacious one, two, and three-bedroom layouts are designed for hassle-free living, providing you with more time to enjoy the things you love.\n\nBeyond dishwashers, residents at Baystone enjoy additional amenities such as a fitness center, cabana, high-speed Wi-Fi, and package service. Situated in a vibrant community with on-site management, Baystone Apartments offers both comfort and convenience. Enjoy quick access to local attractions and the dynamic environs of the Webster area. Experience the perfect blend of functionality and style at Baystone Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019d0783-f4bc-713b-9e3e-08df5e2478a4.webp",
      "featured_image_media": {
        "alt_text": "A beautiful outdoor swimming pool with a red bridge and lush landscaping.",
        "public_id": "019d0783-f4bc-713b-9e3e-08df5e2478a4",
        "storage_key": "property/6737460151192625/019d0783-f4bc-713b-9e3e-08df5e2478a4.webp",
        "width": 1239,
        "height": 837
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts with Dishwasher Near Nasa Parkway",
      "seo_description": "Enjoy modern kitchens with dishwashers at Baystone Apartments, conveniently located near Nasa Parkway in Webster. Explore our amenities—visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "generator",
      "page_item_url": "family-friendly-apartments-playground-webster-tx",
      "search_query": "family-friendly apartments with playground Webster TX",
      "category": "Amenity",
      "h1_title": "Family-Friendly Apartments in Webster, TX",
      "h2_subtitle": "Enjoy family-friendly living with a playground at Baystone Apartments in Webster, TX. Discover spacious homes and community amenities for all ages.",
      "page_copy": "Baystone Apartments in Webster, TX, offers the ideal family-friendly environment where children can play freely in our community playground. Nestled in a vibrant community, these spacious one, two, and three-bedroom floor plans cater to families looking for a comfortable home base with easy access to local attractions and schools.\n\nOur family-focused amenities extend beyond the playground, offering residents a fitness center, package service, and on-site management to ensure peace of mind. Located in the welcoming neighborhood of Webster, TX, Baystone Apartments promises a balanced lifestyle filled with ease and enjoyment. Explore a community designed with families in mind and discover why Baystone is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019d0783-f4bc-713b-9e3e-08df5e2478a4.webp",
      "featured_image_media": {
        "alt_text": "A beautiful outdoor swimming pool with a red bridge and lush landscaping.",
        "public_id": "019d0783-f4bc-713b-9e3e-08df5e2478a4",
        "storage_key": "property/6737460151192625/019d0783-f4bc-713b-9e3e-08df5e2478a4.webp",
        "width": 1239,
        "height": 837
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Family-Friendly Apartments with Playground in Webster",
      "seo_description": "Discover Baystone Apartments: family-friendly and equipped with a playground in Webster, TX. Perfect for families seeking spacious and vibrant living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-webster-tx",
      "search_query": "one bedroom apartments webster tx",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Webster, TX",
      "h2_subtitle": "Explore superb one-bedroom apartments at Baystone in Webster, TX. Experience comfort, convenience, and a welcoming community.",
      "page_copy": "Discover the perfect one-bedroom apartments at Baystone Apartments in Webster, TX, where style meets functionality. Our thoughtfully designed layouts ensure you have ample space and comfort, ideal for singles or couples seeking a cozy and manageable living environment.\n\nAt Baystone, you'll enjoy access to top-notch amenities such as a fitness center, cable readiness, Wi-Fi, and our dedicated on-site management. Nestled in the vibrant heart of Webster, TX, our community provides the perfect blend of convenience and tranquility. Whether you're moving to the area or looking for a fresh start, our one-bedroom apartments offer a welcoming home tailored to your lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019d0783-f4bc-713b-9e3e-08df5e2478a4.webp",
      "featured_image_media": {
        "alt_text": "A beautiful outdoor swimming pool with a red bridge and lush landscaping.",
        "public_id": "019d0783-f4bc-713b-9e3e-08df5e2478a4",
        "storage_key": "property/6737460151192625/019d0783-f4bc-713b-9e3e-08df5e2478a4.webp",
        "width": 1239,
        "height": 837
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Webster, TX",
      "seo_description": "Baystone Apartments offers cozy one-bedroom homes in Webster, TX. Enjoy modern amenities and a prime location. Find your new home today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-near-nasa-parkway",
      "search_query": "two bedroom apartments near nasa parkway",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near Nasa Parkway",
      "h2_subtitle": "Explore spacious two-bedroom apartments at Baystone, conveniently located near Nasa Parkway in Webster, TX. Ideal for a comfortable living experience.",
      "page_copy": "Baystone Apartments invites you to explore our spacious two-bedroom floor plans, perfectly situated near Nasa Parkway in Webster, TX. Tailored for those seeking both comfort and convenience, our two-bedroom homes offer ample living space, suitable for small families, roommates, or anyone desiring more room.\n\nEach apartment is equipped with modern amenities, including access to a fitness center, cable-ready units, high-speed Wi-Fi, and package service. Located in a thriving community just moments away from the hustle and bustle of Nasa Parkway, Baystone Apartments provides an ideal setting for a vibrant lifestyle with easy access to local attractions and necessities. Make your next move stress-free and exciting at Baystone Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019d0783-f4bc-713b-9e3e-08df5e2478a4.webp",
      "featured_image_media": {
        "alt_text": "A beautiful outdoor swimming pool with a red bridge and lush landscaping.",
        "public_id": "019d0783-f4bc-713b-9e3e-08df5e2478a4",
        "storage_key": "property/6737460151192625/019d0783-f4bc-713b-9e3e-08df5e2478a4.webp",
        "width": 1239,
        "height": 837
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near Nasa Parkway",
      "seo_description": "Find spacious two-bedroom apartments at Baystone, located near Nasa Parkway in Webster, TX. Ideal for families or roommates. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192625",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-harris-county",
      "search_query": "three bedroom apartments in harris county",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Harris County",
      "h2_subtitle": "Discover spacious three-bedroom apartments at Baystone in Harris County. Perfect for families seeking comfort and convenience in Webster, TX.",
      "page_copy": "Baystone Apartments in Webster, TX, is the perfect choice for those searching for expansive three-bedroom apartments within Harris County. Our generously sized floor plans are designed to accommodate larger families or those who simply desire more room to live and entertain.\n\nSet in a prime location, Baystone Apartments offer convenient access to countless amenities such as a modern fitness center, seamless cable connectivity, and reliable Wi-Fi. The community exudes a welcoming atmosphere with on-site management and package services, ensuring that every need is met promptly. Embrace the blend of space and style in our three-bedroom homes, ideal for establishing roots in Harris County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192625/019d0783-f4bc-713b-9e3e-08df5e2478a4.webp",
      "featured_image_media": {
        "alt_text": "A beautiful outdoor swimming pool with a red bridge and lush landscaping.",
        "public_id": "019d0783-f4bc-713b-9e3e-08df5e2478a4",
        "storage_key": "property/6737460151192625/019d0783-f4bc-713b-9e3e-08df5e2478a4.webp",
        "width": 1239,
        "height": 837
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Harris County",
      "seo_description": "Spacious three-bedroom apartments available at Baystone in Harris County. Ideal for families needing comfort and space in Webster, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3363"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "5028483227"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4707259"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.baystoneapthome.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.baystoneapthome.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.baystoneapthome.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.baystoneapthome.com?utm_knock=w"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-N8RVBD4X"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.baystoneapthome.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://www.baystoneapthome.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.baystoneapthome.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.baystoneapthome.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.baystoneapthome.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.baystoneapthome.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "281-957-1627"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.baystoneapthome.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.baystoneapthome.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "281-603-9751"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.baystoneapthome.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.baystoneapthome.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.baystoneapthome.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_psa_link",
      "type": "STRING",
      "value": "https://www.baystoneapthome.com?utm_knock=psa"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "281-957-8109"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "281-377-4461"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "281-426-0943"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://www.baystoneapthome.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "281-542-3407"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "281-524-3674"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "281-377-8242"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "281-645-5389"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "281-377-7854"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.baystoneapthome.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_knock_psa_title",
      "type": "STRING",
      "value": "Paid Social Ads"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "281-918-7835"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.baystoneapthome.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "281-783-3899"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.baystoneapthome.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "361-273-7601"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "361-282-4323"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.baystoneapthome.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "281-502-4912"
    },
    {
      "ID": "custom_knock_psa_number",
      "type": "STRING",
      "value": "281-730-5291"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "281-903-5605"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://www.baystoneapthome.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.baystoneapthome.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "281-867-5649"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "17321291127"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "281-377-0757"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "508-593-9563"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.baystoneapthome.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "eddae7401c3a11ee"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.baystoneapthome.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "361-273-6031"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.baystoneapthome.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "281-559-6363"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "281-377-0657"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.baystoneapthome.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "361-202-9231"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "281-609-6725"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "281-502-4047"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "281-937-3683"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.baystoneapthome.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://media.multihub.io/property/6737460151192625/019e60d9-6d6c-7774-80e5-fa5b2a247285.mp4"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "281-717-6684"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "281-377-7854"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "3363",
  "custom_repli_id": "5028483227",
  "custom_realpage_id": "4707259",
  "custom_knock_a_link": "https://www.baystoneapthome.com?utm_knock=a",
  "custom_knock_g_link": "https://www.baystoneapthome.com?utm_knock=g",
  "custom_knock_r_link": "https://www.baystoneapthome.com?utm_knock=r",
  "custom_knock_w_link": "https://www.baystoneapthome.com?utm_knock=w",
  "custom_google_gtm_id": "GTM-N8RVBD4X",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_al_link": "https://www.baystoneapthome.com?utm_knock=al",
  "custom_knock_ar_link": "https://www.baystoneapthome.com?utm_knock=ar",
  "custom_knock_cl_link": "https://www.baystoneapthome.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.baystoneapthome.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.baystoneapthome.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.baystoneapthome.com?utm_knock=gp",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_w_title": "Property Website",
  "custom_knock_a_number": "281-957-1627",
  "custom_knock_ads_link": "https://www.baystoneapthome.com?utm_knock=ads",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "https://www.baystoneapthome.com?utm_knock=bnr",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "281-603-9751",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://www.baystoneapthome.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.baystoneapthome.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.baystoneapthome.com?utm_knock=ppn",
  "custom_knock_psa_link": "https://www.baystoneapthome.com?utm_knock=psa",
  "custom_knock_r_number": "281-957-8109",
  "custom_knock_w_number": "281-377-4461",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_al_number": "281-426-0943",
  "custom_knock_amap_link": "https://www.baystoneapthome.com?utm_knock=amap",
  "custom_knock_ar_number": "281-542-3407",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_cl_number": "281-524-3674",
  "custom_knock_fb_number": "281-377-8242",
  "custom_knock_fl_number": "281-645-5389",
  "custom_knock_gp_number": "281-377-7854",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.baystoneapthome.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_knock_psa_title": "Paid Social Ads",
  "custom_ads_subscription": "essential",
  "custom_knock_ads_number": "281-918-7835",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "https://www.baystoneapthome.com?utm_knock=bcard",
  "custom_knock_bnr_number": "281-783-3899",
  "custom_knock_cfres_link": "https://www.baystoneapthome.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "361-273-7601",
  "custom_knock_lgp_number": "361-282-4323",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.baystoneapthome.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "281-502-4912",
  "custom_knock_psa_number": "281-730-5291",
  "custom_seo_subscription": "essential",
  "custom_knock_amap_number": "281-903-5605",
  "custom_knock_bandit_link": "https://www.baystoneapthome.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.baystoneapthome.com?utm_knock=flyers",
  "custom_knock_osoc_number": "281-867-5649",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "17321291127",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "281-377-0757",
  "custom_knock_cfres_number": "508-593-9563",
  "custom_knock_chatgpt_link": "https://www.baystoneapthome.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "eddae7401c3a11ee",
  "custom_knock_dirmail_link": "https://www.baystoneapthome.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "361-273-6031",
  "custom_knock_propbro_link": "https://www.baystoneapthome.com?utm_knock=propbro",
  "custom_knock_bandit_number": "281-559-6363",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "281-377-0657",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.baystoneapthome.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "361-202-9231",
  "custom_knock_dirmail_number": "281-609-6725",
  "custom_knock_propbro_number": "281-502-4047",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_revcards_number": "281-937-3683",
  "custom_knock_maintenance_link": "https://www.baystoneapthome.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_property_featured_video": "https://media.multihub.io/property/6737460151192625/019e60d9-6d6c-7774-80e5-fa5b2a247285.mp4",
  "custom_knock_maintenance_number": "281-717-6684",
  "custom_ppc_tracking_phone_number": "281-377-7854"
};

export const generatedAt = '2026-10-07T17:14:15.700Z';
